{
  "cardRecord": {
    "expand": "Expandir registro",
    "collapse": "Contraer registro"
  },
  "reservedMaterialReview": {
    "operation": "Operación {{number}}",
    "reserved": "Reserva pendiente: {{amount}}",
    "quantity": "Cantidad a consumir de {{code}}",
    "refresh": "Vuelva al panel y abra la revisión para actualizar el saldo y el vínculo de la reserva."
  },
  "accessRestricted": {
    "title": "Acceso restringido",
    "body": "Tu rol no permite acceder a esta página. Habla con el administrador de tu cuenta."
  },
  "notFound": {
    "title": "Página no encontrada",
    "body": "La dirección no corresponde a una página disponible. Vuelve al chat para continuar.",
    "back": "Volver al chat"
  },
  "symptomPrompt": {
    "title": "SÍNTOMA",
    "question": "¿Qué pasó con el equipo? Descríbalo con sus propias palabras.",
    "placeholder": "Ej.: fuga de aceite en el sello de la bomba",
    "helper": "Escriba el problema como se lo contaría a un colega.",
    "submitLabel": "Enviar"
  },
  "procedureAuthoring": {
    "title": "CREAR PROCEDIMIENTO",
    "escolha": {
      "greeting": "¡Hola, {{name}}! ¿Qué quieres hacer?"
    },
    "rascunhos": {
      "title": "Mis borradores",
      "empty": "No tienes borradores.",
      "resume": "Continuar",
      "steps_one": "{{count}} paso",
      "steps_other": "{{count}} pasos"
    },
    "equipamento": {
      "title": "Equipo",
      "searchLabel": "Buscar por código o nombre",
      "searchButton": "Buscar",
      "select": "Seleccionar",
      "empty": "No se encontró ningún equipo."
    },
    "pontoDePartida": {
      "question_one": "¿Usar el paso simple del plan de este equipo?",
      "question_other": "¿Usar los {{count}} pasos simples del plan de este equipo?"
    },
    "cabecalho": {
      "title": "Encabezado",
      "name": "Nombre del procedimiento",
      "namePlaceholder": "Ej.: Cambio del sello de la bomba",
      "objective": "Objetivo",
      "safety": "Seguridad (bloqueo, EPP)",
      "safetyPlaceholder": "Opcional",
      "duration": "Duración (minutos)",
      "crew": "Equipo de trabajo"
    },
    "passo": {
      "title": "Paso {{index}}",
      "titleOf": "Paso {{index}} de {{total}}",
      "text": "Qué hacer en este paso",
      "textPlaceholder": "Ej.: Apaga y bloquea la bomba antes de abrir la tapa",
      "camera": "Cámara",
      "importImage": "Importar imagen",
      "photos": "Fotos del paso",
      "photoItem": "Foto {{n}}",
      "removePhoto": "Quitar foto {{n}}",
      "uploading": "Enviando foto...",
      "photoFailed": "No se pudo enviar la foto.",
      "photoTooLarge": "La foto sigue pesando más de 1 MB. Prueba con otra."
    },
    "revisao": {
      "title": "Revisión",
      "summary_one": "{{count}} paso, {{photos}} con foto",
      "summary_other": "{{count}} pasos, {{photos}} con foto",
      "editStep": "Editar paso {{n}}",
      "editLabel": "Editar un paso"
    },
    "vinculo": {
      "title": "Vincular equipos",
      "question": "¿Vincular ahora a uno o más equipos?",
      "none": "No hay equipos disponibles."
    },
    "pausado": {
      "title": "Borrador guardado",
      "body": "Para continuar: /criar-procedimento y Continuar borrador."
    },
    "concluido": {
      "title": "Procedimiento",
      "steps_one": "{{count}} paso",
      "steps_other": "{{count}} pasos",
      "photos_one": "{{count}} foto",
      "photos_other": "{{count}} fotos",
      "equipment_one": "{{count}} equipo vinculado",
      "equipment_other": "{{count}} equipos vinculados",
      "statusCreated": "Borrador",
      "statusReleased": "Publicado"
    }
  },
  "procFoto": {
    "coluna": "Foto",
    "camera": "Cámara",
    "importar": "Importar imagen",
    "pular": "Omitir",
    "adicionar": "Agregar foto",
    "naoConsigo": "No puedo fotografiar",
    "motivoLabel": "Motivo para no fotografiar",
    "motivoPlaceholder": "Ej.: sin luz en el lugar",
    "enviando": "Enviando foto…",
    "erroGrande": "La foto sigue siendo demasiado grande aun comprimida. Toma otra con menos detalle.",
    "erroIlegivel": "Formato no compatible. Usa una foto JPG o PNG.",
    "erroEnvio": "No se pudo enviar la foto. Inténtalo de nuevo.",
    "previa": "Vista previa de la foto",
    "remover": "Quitar foto",
    "ampliar": "Ampliar foto",
    "fechar": "Cerrar",
    "fotoAlt": "Foto adjunta",
    "carregando": "Cargando foto…",
    "indisponivel": "Foto no disponible",
    "politica": {
      "title": "FOTO EN AVISO Y ORDEN",
      "intro": "Elige cuándo se pide la foto. El cambio vale para toda la empresa.",
      "notificacao": "Aviso",
      "ordem": "Orden de trabajo",
      "off": "Desactivada",
      "optional": "Opcional",
      "required": "Obligatoria",
      "salvar": "Guardar política",
      "somenteLeitura": "Solo los administradores pueden cambiar esta política.",
      "salvo": "Política de foto guardada"
    }
  },
  "admin": {
    "title": "Panel de Administración",
    "subtitle": "Vista operacional de su operación.",
    "loading": "Cargando datos de administración…",
    "forbidden": "No tienes permiso para ver esta página.",
    "error": "No se pudieron cargar los datos de administración. Inténtalo de nuevo.",
    "metrics": {
      "totalEquipments": "Equipos totales",
      "activeEquipments": "Equipos activos",
      "openWorkOrders": "Órdenes de trabajo abiertas",
      "openNotifications": "Notificaciones abiertas",
      "criticalNotifications": "Notificaciones críticas",
      "activeMaintPlans": "Planes de mantenimiento activos",
      "completedWoThisMonth": "OT completadas este mes",
      "pmc": "Cumplimiento de mantenimiento planificado (%)",
      "totalPlants": "Plantas",
      "totalLocations": "Ubicaciones",
      "goToSection": "Ver {{section}}",
      "draftMaintPlans": "Planes en borrador"
    },
    "tabs": "Secciones de administración",
    "tabDashboard": "Panel",
    "tabEntities": "Explorador de entidades",
    "backToConversation": "Volver a la conversación",
    "sectionMenu": "Menú de secciones",
    "sections": {
      "dashboard": "Panel",
      "equipment": "Equipos",
      "plants": "Plantas",
      "locations": "Ubicaciones",
      "materials": "Materiales",
      "workOrders": "Órdenes de trabajo",
      "maintPlans": "Planes de mantenimiento",
      "notifications": "Notificaciones",
      "proposals": "Propuestas (IA)",
      "auditLog": "Registro de auditoría",
      "sessions": "Sesiones",
      "skills": "Skills",
      "inventoryTurnover": "Rotación de inventario",
      "recursos": "Recursos",
      "specialties": "Especialidades",
      "config": "Configuración",
      "i18n": "Idiomas",
      "entities": "Explorador de entidades",
      "flowGraph": "Flujo del Axis"
    },
    "flowGraph": {
      "subtitle": "Grafo del flujo de incorporación: cada nodo es una pantalla, decisión o razonamiento del Axis, y cada arista es una transición determinística del flujo.",
      "hint": "Pase el mouse sobre un nodo para resaltar sus conexiones. Haga clic para que el Axis retome el recorrido desde ahí. Arrastre para reorganizar.",
      "canvasLabel": "Grafo del flujo de incorporación del Axis",
      "legend": {
        "render": "Pantalla (muestra algo)",
        "decision": "Decisión (el usuario elige)",
        "agentic": "Razonamiento del Axis (investigación)",
        "pending": "En cola (por construir)"
      },
      "zones": {
        "onboarding": "Incorporación",
        "operations": "Operación del día a día"
      }
    },
    "proposals": {
      "subtitle": "Propuestas generadas por IA pendientes de revisión.",
      "filterStatus": "Filtrar por estado",
      "empty": "No se encontraron propuestas.",
      "showItems": "Ver ítems",
      "hideItems": "Ocultar ítems",
      "approve": "Aprobar",
      "reject": "Rechazar",
      "status": {
        "all": "Todos los estados",
        "pending": "Pendiente",
        "approved": "Aprobada",
        "partial": "Parcial",
        "rejected": "Rechazada",
        "expired": "Expirada",
        "auto_approved": "Aprobada automáticamente",
        "executed": "Ejecutada",
        "unknown": "Desconocido"
      },
      "type": {
        "field_update": "Actualizar campo",
        "create_notification": "Crear notificación",
        "create_work_order": "Crear orden de trabajo",
        "horizon_refill": "Recargar horizonte",
        "unknown": "Desconocido"
      },
      "col": {
        "created": "Creada",
        "type": "Tipo",
        "items": "Ítems",
        "field": "Campo",
        "current": "Actual",
        "proposed": "Propuesto",
        "confidence": "Confianza"
      }
    },
    "auditLog": {
      "aiActor": "Asistente de IA",
      "integrationActor": "Integración",
      "unknownActor": "Origen no identificado",
      "actions": {
        "create": "Creación",
        "update": "Actualización",
        "delete": "Eliminación",
        "approve": "Aprobación",
        "reject": "Rechazo",
        "status_change": "Cambio de estado",
        "state_transition": "Progreso de la atención",
        "flow_run_node_persisted": "Paso de conversación registrado",
        "unknown": "Otra acción"
      },
      "systemActor": "Proceso del sistema",
      "unavailableActor": "Usuario no disponible",
      "subtitle": "Rastro de auditoría de cambios en este tenant.",
      "exportCsv": "Exportar CSV",
      "filterEntity": "Filtrar por entidad",
      "filterAction": "Filtrar por acción",
      "allEntities": "Todas las entidades",
      "allActions": "Todas las acciones",
      "dateFrom": "Fecha desde",
      "dateTo": "Fecha hasta",
      "col": {
        "when": "Cuándo",
        "actor": "Autor",
        "entity": "Entidad",
        "action": "Acción",
        "diff": "Cambio"
      }
    },
    "sessions": {
      "subtitle": "Estado del gateway de skills y sesiones activas.",
      "online": "Gateway en línea",
      "offline": "Gateway desconectado",
      "skillsCount": "{{count}} skills cargadas",
      "empty": "No hay sesiones activas.",
      "col": {
        "id": "ID",
        "channel": "Canal",
        "user": "Usuario",
        "lastActivity": "Última actividad",
        "status": "Estado"
      }
    },
    "skills": {
      "subtitle": "Skills cargadas por el gateway.",
      "empty": "No hay skills cargadas.",
      "noDescription": "Sin descripción"
    },
    "inventory": {
      "subtitle": "Materiales en exceso ordenados por capital inmovilizado.",
      "selectPlant": "Seleccione una planta…",
      "searchPlaceholder": "código o descripción",
      "choosePlantHint": "Seleccione una planta para ver la rotación de inventario.",
      "empty": "No hay materiales en exceso en esta planta.",
      "excess": "Exceso",
      "col": {
        "code": "Código",
        "description": "Descripción",
        "unit": "Unidad",
        "currentStock": "Stock actual",
        "available": "Disponible",
        "maxStock": "Stock máx.",
        "excessQty": "Exceso",
        "capital": "Capital inmovilizado",
        "status": "Estado"
      }
    },
    "recursos": {
      "subtitle": "Plantel de recursos (técnicos) y su capacidad.",
      "searchPlaceholder": "nombre, email o legajo",
      "filterPlant": "Filtrar por planta",
      "filterRole": "Filtrar por función",
      "allPlants": "Todas las plantas",
      "allRoles": "Todas las funciones",
      "empty": "No se encontraron recursos.",
      "col": {
        "name": "Nombre",
        "role": "Función",
        "team": "Equipo",
        "plant": "Planta",
        "email": "Email",
        "personnel": "Legajo",
        "weekly": "Capacidad semanal",
        "daily": "Capacidad diaria"
      }
    },
    "specialties": {
      "title": "Especialidades de Mantenimiento",
      "subtitle": "Gestione las disciplinas técnicas de su equipo. Cada equipo se vincula a una especialidad.",
      "columns": {
        "name": "Nombre",
        "slug": "Código",
        "status": "Estado",
        "isDefault": "Predeterminada"
      },
      "namePlaceholder": "Nombre de la especialidad",
      "addButton": "Agregar",
      "editButton": "Editar",
      "saveButton": "Guardar",
      "cancelButton": "Cancelar",
      "deleteButton": "Eliminar",
      "deactivateButton": "Desactivar",
      "activateButton": "Activar",
      "showInactive": "Mostrar inactivas",
      "active": "Activa",
      "inactive": "Inactiva",
      "isDefault": "Sistema",
      "confirmDelete": "¿Eliminar esta especialidad? Los equipos vinculados impiden la eliminación.",
      "empty": "Ninguna especialidad activa. Cree la primera.",
      "errors": {
        "inUse": "En uso por {{count}} equipo(s). Desactive en lugar de eliminar.",
        "isDefault": "Las especialidades predeterminadas del sistema no se pueden eliminar. Desactívelas.",
        "saveFailed": "Error al guardar. Inténtelo de nuevo.",
        "loadFailed": "Error al cargar especialidades."
      },
      "seeds": {
        "mechanical": "Mecánica",
        "electrical": "Eléctrica",
        "instrumentation": "Instrumentación",
        "lubrication": "Lubricación",
        "operator": "Operador",
        "general": "General"
      }
    },
    "config": {
      "subtitle": "Parámetros del harness (whitelist).",
      "searchPlaceholder": "key o descripción",
      "filterScope": "Filtrar por alcance",
      "allScopes": "Todos los alcances",
      "saved": "Guardado",
      "reset": "Restablecido",
      "resetBtn": "Restablecer",
      "saveFailed": "No se pudo guardar.",
      "invalidJson": "JSON inválido.",
      "confirmReset": "¿Restablecer este parámetro a su valor por defecto?",
      "default": "Default (no sobrescrito)",
      "overridden": "Sobrescrito",
      "overriddenBy": "Actualizado por {{name}}"
    },
    "reset": {
      "reveal": "Zona de riesgo",
      "warning": "Esto BORRA toda la base (todos los datos) y la recrea desde cero. Acción irreversible.",
      "passwordLabel": "Contraseña de reinicio",
      "confirm": "Reiniciar base",
      "confirmAgain": "Confirmar reinicio, haz clic de nuevo",
      "running": "Reiniciando la base…",
      "success": "Base reiniciada correctamente.",
      "wrongPassword": "Contraseña incorrecta.",
      "cooldown": "Espera unos segundos antes de reiniciar de nuevo.",
      "forbidden": "Reinicio no permitido en este entorno.",
      "error": "No se pudo reiniciar la base."
    },
    "dangerZone": {
      "typedLabel": "Escribe {{phrase}} para confirmar",
      "unavailable": "Esta acción está disponible solo para el Owner o el Admin de la empresa en una base de prueba autorizada.",
      "title": "Zona de peligro",
      "buttonLabel": "Reiniciar base ahora",
      "warning": "Esta acción elimina los datos operativos de la empresa actual en {{environment}} y recrea su base. Se conservan las cuentas, autenticación, auditoría y datos de otras empresas. Irreversible.",
      "confirm1Warning": "¿Confirmar la eliminación de los datos operativos de la empresa actual en {{environment}}? Esta acción no se puede deshacer.",
      "proceedToPassword": "Sí, continuar",
      "passwordLabel": "Ingresa la contraseña de reinicio de la base",
      "passwordPlaceholder": "Contraseña de reinicio",
      "confirmButton": "Confirmar reinicio total",
      "submitting": "Reiniciando…",
      "cancel": "Cancelar",
      "successToast": "Base {{environment}} reiniciada correctamente.",
      "wrongSecret": "Contraseña de reinicio incorrecta.",
      "cooldown": "Espera unos segundos antes de reiniciar de nuevo.",
      "genericError": "No se pudo reiniciar la base. Inténtalo de nuevo.",
      "noPermission": "Solo el Owner o el Admin de la empresa pueden reiniciar la base.",
      "locked": "Contraseña de reinicio incorrecta 3 veces. El reinicio queda bloqueado por {{minutes}} min.",
      "verificationUnavailable": "No fue posible verificar la contraseña de reinicio ahora. Inténtalo de nuevo en unos minutos.",
      "reauthExpired": "La confirmación expiró. Ingresa la contraseña de reinicio de nuevo.",
      "sessionExpired": "Tu sesión expiró. Inicia sesión de nuevo y repite el reinicio.",
      "setupTitle": "Define la contraseña de reinicio de la base",
      "setupHint": "Antes del primer reinicio, define aquí una contraseña solo para esta acción. Es independiente del inicio de sesión, así que también sirve si entras con Google. Mínimo {{min}} caracteres.",
      "newPasswordLabel": "Nueva contraseña de reinicio",
      "confirmPasswordLabel": "Repite la nueva contraseña de reinicio",
      "saveSetup": "Guardar contraseña de reinicio",
      "saving": "Guardando…",
      "setupSaved": "Contraseña de reinicio guardada. Ya puedes reiniciar la base.",
      "tooShort": "La contraseña de reinicio debe tener al menos {{min}} caracteres.",
      "mismatch": "Las dos contraseñas no coinciden.",
      "resetPasswordNotSet": "Esta base aún no tiene contraseña de reinicio. Defínela aquí mismo, en esta pantalla.",
      "alreadySet": "La contraseña de reinicio ya está definida. Para cambiarla, ingresa la actual.",
      "changeTitle": "Cambiar la contraseña de reinicio",
      "currentPasswordLabel": "Contraseña de reinicio actual",
      "saveChange": "Cambiar contraseña de reinicio",
      "changeSaved": "Contraseña de reinicio cambiada.",
      "resetNotApplied": "La limpieza no se aplicó: los datos se conservaron. Después de corregir la causa, ingresa de nuevo la contraseña de reinicio para confirmar otro intento.",
      "resetPartial": "El servidor informó de una limpieza posiblemente parcial. Comprueba su estado antes de iniciar otra limpieza.",
      "resetOutcomeUnknown": "No se pudo confirmar el resultado de la limpieza. Comprueba su estado antes de iniciar otra limpieza.",
      "retryButton": "Confirmar otro intento de limpieza",
      "serverTimestamp": "Hora informada por el servidor:",
      "checkStatus": "Comprobar estado de la limpieza",
      "checkingStatus": "Comprobando estado…",
      "resetStillRunning": "Todavía hay una limpieza en curso para esta empresa. Espera y comprueba su estado de nuevo.",
      "resetStatusUnavailable": "No se pudo comprobar el estado ahora. No se inició otra limpieza.",
      "operationReference": "Referencia de la operación:",
      "resetMaintenanceUnavailable": "La limpieza segura de esta base no está disponible temporalmente. Es necesario corregir la configuración del entorno; mientras tanto no se iniciará otra limpieza.",
      "newCleanupWarning": "El resultado anterior sigue sin confirmación de éxito. Iniciar otra limpieza requiere una nueva confirmación y contraseña; no confirma ni reanuda la operación anterior.",
      "startNewCleanup": "Iniciar una nueva limpieza",
      "resetAlreadyRunning": "Ya hay una limpieza en curso para esta empresa. Comprueba su estado antes de iniciar otra."
    },
    "i18n": {
      "subtitle": "Configuración de idiomas del harness.",
      "supportedLanguages": "Idiomas soportados",
      "defaultLanguage": "Idioma por defecto",
      "fallbackLanguage": "Idioma de respaldo",
      "detectionStrategy": "Estrategia de detección",
      "allowUserOverride": "Permitir override del usuario",
      "addLang": "Agregar",
      "removeLang": "Eliminar {{lang}}",
      "invalidTag": "Etiqueta BCP-47 inválida.",
      "saved": "Guardado",
      "saveFailed": "No se pudo guardar."
    },
    "grid": {
      "search": "Buscar",
      "searchPlaceholder": "Buscar registros…",
      "filters": "Filtros",
      "filtersGroup": "Filtros por columna",
      "filterPlaceholder": "Valor…",
      "filterBy": "Filtrar por {{field}}",
      "columns": "Columnas",
      "compact": "Compacto",
      "comfortable": "Cómodo",
      "refresh": "Actualizar",
      "export": "Exportar Excel",
      "exporting": "Exportando…",
      "exportFailed": "Error al exportar. Inténtalo de nuevo.",
      "exportTooLarge": "Demasiadas filas para exportar, refina el filtro e inténtalo de nuevo.",
      "clearAll": "Limpiar todo",
      "removeFilter": "Quitar el filtro de {{field}}",
      "tableCaption": "Registros de la entidad",
      "expandColumn": "Expandir fila",
      "expandRow": "Expandir fila",
      "collapseRow": "Contraer fila",
      "copyId": "Copiar ID",
      "copied": "Copiado",
      "pagination": "Paginación",
      "totalRows": "Total de registros:",
      "prev": "Anterior",
      "next": "Siguiente",
      "jumpToPage": "Ir a la página",
      "ofPages": "de {{count}}",
      "empty": "Ningún registro coincide con los filtros actuales.",
      "loadError": "No se pudieron cargar los registros.",
      "retry": "Reintentar",
      "schemaError": "No se pudo cargar el esquema del modelo.",
      "selectModel": "Selecciona un modelo para explorar.",
      "searchModels": "Buscar modelos…",
      "modelList": "Modelos"
    },
    "workOrderDetail": {
      "descriptionTitle": "Descripción",
      "longTextLabel": "Texto largo",
      "notificationTitle": "Notificación Vinculada",
      "notificationCol": {
        "id": "ID",
        "description": "Descripción"
      },
      "operationsTitle": "Operaciones ({{count}})",
      "operationsEmpty": "Ninguna operación registrada",
      "operationsCol": {
        "seq": "Sec",
        "description": "Descripción",
        "plannedDuration": "Duración Plan.",
        "technician": "Técnico",
        "status": "Estado"
      },
      "componentsTitle": "Materiales ({{count}})",
      "componentsEmpty": "Ningún componente vinculado",
      "componentsCol": {
        "material": "Material",
        "description": "Descripción",
        "qty": "Cant",
        "unit": "Unid",
        "origin": "Origen"
      },
      "needsPurchase": "Compra",
      "fromStock": "Stock"
    }
  },
  "common": {
    "yes": "Sí",
    "no": "No",
    "appName": "AxiomGO",
    "tagline": "AI Guidance & Maintenance Orchestration",
    "send": "Enviar",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "close": "Cerrar",
    "loading": "Cargando...",
    "retry": "Reintentar",
    "settings": "Configuración",
    "help": "Ayuda",
    "delete": "Eliminar"
  },
  "chat": {
    "composerRecovery": {
      "storageFailed": "No se pudo preparar el envío. El texto se conservó. Inténtalo de nuevo.",
      "available": "El texto del envío anterior está disponible para revisar.",
      "restore": "Recuperar el texto"
    },
    "expandCard": {
      "expand": "Expandir tarjeta",
      "expandedBadge": "Tarjeta abierta en pantalla completa",
      "title": {
        "equipment_search": "Resultado del equipo",
        "import": "Importación",
        "kpi": "Indicadores",
        "plan_edit": "Plan de mantenimiento: revisar",
        "preventive_draft": "Plan preventivo: borrador",
        "proposal": "Propuesta",
        "resource_allocation": "Asignación de recursos",
        "task_materials": "Materiales por tarea",
        "web_search": "Sugerencia de plan, armada por Axis"
      }
    },
    "placeholder": "Pregunte sobre activos, fallas, planes u órdenes…",
    "axisKPanelSubtitle": "Describa un problema o pida un análisis técnico",
    "placeholders": [
      "Escriba / para ver qué puedo hacer",
      "Registre un equipo: etiqueta, fabricante y modelo",
      "Arme una sugerencia de plan a partir del manual del fabricante",
      "Pregunte: ¿por qué está vibrando el compresor GA37?"
    ],
    "placeholderByFlow": {
      "corretiva": "Describa la falla y yo abro la orden de trabajo",
      "preventiva": "Ajuste los intervalos o las tareas del plan de mantenimiento"
    },
    "commandPalette": {
      "notifications": "Listar notificaciones",
      "unavailable": "Comandos no disponibles",
      "empty": "Ningún comando. Envíe como texto"
    },
    "disclaimer": "AxiomGO puede cometer errores. Confirme las acciones antes de ejecutarlas.",
    "newConversation": "Nueva conversación",
    "copyConversation": "Copiar conversación",
    "copyConversationRoleUser": "Tú",
    "history": "Historial",
    "typing": "Escribiendo...",
    "noConversations": "Aún no hay conversaciones",
    "mockResponse": "recibió tu mensaje. La integración con el Motor está pendiente.",
    "reconnectAttempt": "intento {{count}}",
    "suggestedActions": "Acciones sugeridas",
    "assistant_avatar_alt": "AxiomGO",
    "stopProcessing": "Detener",
    "cancel": "Cancelar",
    "turnTimedOut": "La respuesta tardó demasiado. Inténtalo de nuevo.",
    "turnGaveUp": "La respuesta no llegó a terminar. No se perdió nada de lo que ya tenías: toca \"Intentar de nuevo\" para retomarlo.",
    "inactivity": {
      "pausedAt": "Pausado por inactividad · {{time}}.",
      "saved": "Tu hoja de cálculo sigue guardada.",
      "resume": "Retomar"
    },
    "copyMessage": "Copiar mensaje",
    "retryMessage": "Intentar de nuevo",
    "criticalConfirmation": {
      "materialConsumption": {
        "title": "Confirmar consumo de material",
        "confirm": "Confirmar consumo",
        "prompt": "¿Confirmar el consumo de {{items}}?",
        "promptWithOrder": "¿Confirmar el consumo de {{items}} en la orden {{order}}?"
      },
      "workOrderClosure": {
        "title": "Confirmar cierre de la orden",
        "confirm": "Confirmar cierre"
      },
      "yes": "Sí",
      "no": "No",
      "confirmMessage": "Sí, confirmo.",
      "expiredNote": "La confirmación expiró. Solicita la acción nuevamente.",
      "unboundNote": "No pude identificar la conversación de esta confirmación. Solicita la acción de nuevo.",
      "cancelledNote": "Acción cancelada.",
      "ariaLabel": "Confirmación de acción crítica",
      "closeNoteLabel": "Nota de cierre",
      "closeNotePlaceholder": "Describa lo que se realizó…",
      "closeNoteCounter": "{{count}} caracteres",
      "closeNoteCounterMinimum": "{{count}} de {{minChars}} caracteres mínimos",
      "wandLabel": "Mejorar nota",
      "wandPending": "Mejorando nota…"
    },
    "deliveryFailed": "Error al enviar, toca \"Intentar de nuevo\"",
    "deliveryFailedShort": "Falló",
    "emptyResponseHint": "Esta respuesta no llegó esta vez. Toca \"Intentar de nuevo\" o reformula la pregunta.",
    "actionFailure": {
      "notCompleted": "no se completó"
    },
    "reasoning": {
      "thinking": "Pensando...",
      "done": "Detalles de la respuesta",
      "failed": "Procesamiento interrumpido",
      "stalledHint": "Procesando, un momento...",
      "error": "La respuesta se interrumpió.",
      "retry": "Reintentar"
    },
    "message": {
      "renderError": {
        "title": "No pudimos mostrar esta respuesta",
        "body": "El contenido de este mensaje llegó dañado. El resto de la conversación sigue funcionando. Toque \"Reintentar\" para reenviar su último mensaje.",
        "retry": "Reintentar"
      }
    },
    "onboardingWaiting": {
      "preparing": "Preparando su bienvenida..."
    },
    "onboardingUploadCard": {
      "attachButton": "Adjuntar planilla",
      "dropHint": "o arrastra el archivo aquí",
      "sent": "Planilla enviada"
    },
    "searchWait": {
      "background": "Puedes continuar en otras conversaciones. La investigación sigue en segundo plano y te avisaremos cuando termine.",
      "title": "Investigación técnica en curso",
      "body": "Axis está consultando fuentes en la web: manuales del fabricante y recomendaciones de mantenimiento para fundamentar la respuesta.",
      "duration": "La búsqueda y la preparación del plan pueden tardar hasta 5 minutos.",
      "elapsed": "{{elapsed}} transcurridos"
    },
    "planTasksPartial": {
      "region": "Tareas del plan en validación",
      "badge": "En validación",
      "counter_one": "{{count}} tarea",
      "counter_other": "{{count}} tareas",
      "note": "Vista previa mientras se arma el plan. No se guardó nada; el plan final reemplaza esta tabla."
    },
    "contextMeter": {
      "label": "Uso de contexto",
      "tooltip": "{{tokensK}}/{{limitK}}K tokens",
      "warning": "Conversación cerca del límite, considera iniciar una nueva"
    },
    "fallbackActions": {
      "ariaLabel": "Próximos pasos sugeridos",
      "welcome": {
        "cadastrarEquipamentos": {
          "label": "Registrar mis equipos",
          "value": "quiero registrar mis equipos"
        },
        "montarPlano": {
          "label": "Armar plan de mantenimiento",
          "value": "quiero armar un plan de mantenimiento"
        },
        "comoFunciona": {
          "label": "¿Cómo funciona la gestión?",
          "value": "explica cómo gestiono la ejecución de mantenimiento"
        }
      },
      "equipment": {
        "montarPlanoEsses": {
          "label": "Armar plan para estos equipos",
          "value": "arma un plan para mis equipos registrados"
        }
      },
      "equipmentTag": {
        "assumirDefault": {
          "label": "Usar Tag {{tag}}",
          "value": "usar tag {{tag}}"
        },
        "assumirShort": {
          "label": "Usar Tag {{tag}}",
          "value": "usar tag {{tag}}"
        },
        "preferencia": {
          "label": "Registrar una Tag de mi preferencia",
          "value": "quiero registrar una tag de mi preferencia"
        },
        "outraOpcao": {
          "label": "Sugerir otra opción aleatoria",
          "value": "sugiere otra opción de tag"
        }
      },
      "plan": {
        "iniciarExecucao": {
          "label": "Iniciar ejecución del plan",
          "value": "iniciar ejecución del plan"
        },
        "editarTarefas": {
          "label": "Editar tareas del plan",
          "value": "quiero editar las tareas del plan"
        },
        "adicionarEquipamentos": {
          "label": "Agregar más equipos al plan",
          "value": "agregar equipos al plan"
        }
      },
      "kpi": {
        "verDashboard": {
          "label": "Ver panel completo",
          "value": "muestra el panel de KPI"
        },
        "priorizarMelhorias": {
          "label": "¿Qué mejoras priorizar?",
          "value": "¿qué mejoras debo priorizar según los KPI?"
        },
        "configurarAlertas": {
          "label": "Configurar alertas de KPI",
          "value": "quiero configurar alertas para KPI críticos"
        }
      },
      "searchFailure": {
        "cadastrarManual": {
          "label": "Registrar con datos básicos",
          "value": "puede registrar el equipo con los datos básicos que tenemos"
        },
        "tentarBuscaAlternativa": {
          "label": "Intentar búsqueda alternativa",
          "value": "intenta la búsqueda con términos alternativos"
        },
        "abrirSemCadastro": {
          "label": "Abrir sin registro completo",
          "value": "puede abrir la notificación con los datos básicos sin el registro completo"
        }
      }
    },
    "attachment": {
      "ariaLabel": "Adjunto: {{filename}}, {{size}}",
      "sizeKb": "{{size}} KB",
      "sizeMb": "{{size}} MB"
    },
    "machineEnvelope": {
      "importProgress": "Importación en curso: {{imported}} de {{total}} filas. Le aviso cuando termine.",
      "generic": "Recibí una actualización del sistema que esta versión de la pantalla todavía no sabe mostrar. La operación siguió normalmente."
    },
    "progress": {
      "analyzing": "Procesando con inteligencia artificial...",
      "generating": "Generando respuesta...",
      "reasoning": "Razonando...",
      "searching": "Buscando información en la web...",
      "sources": "Analizando las fuentes encontradas...",
      "tools": "Ejecutando acción..."
    },
    "recommended": "Recomendado",
    "writeYourOwn": "o escríbalo usted mismo",
    "renameFailed": "No se pudo renombrar la conversación. Se mantuvo el nombre anterior.",
    "scrollToBottom": "Ir al final",
    "chips": {
      "grupo": {
        "indicador": "Indicadores",
        "auditoria": "Auditoría de datos"
      }
    }
  },
  "settings": {
    "sections": "Configuración de la cuenta",
    "title": "Preferencias",
    "lang": {
      "label": "Idioma"
    },
    "theme": {
      "label": "Tema",
      "shine": "Shine",
      "night": "Night"
    },
    "notifications": {
      "label": "Avisos del sistema",
      "enable": "Activar avisos del sistema",
      "enabled": "Avisos del sistema activados",
      "denied": "Avisos bloqueados en el navegador. Cámbialo en la configuración del dispositivo.",
      "unsupported": "Este navegador no admite avisos del sistema"
    }
  },
  "sidebar": {
    "userMenu": {
      "open": "Abrir menú de la cuenta de {{name}}",
      "account": "Mi cuenta"
    },
    "models": "Modelos",
    "settings": "Configuración",
    "openSettings": "Abrir preferencias",
    "adminDashboard": "Panel de administración",
    "toggle": "Alternar barra lateral",
    "toggleTheme": "Alternar tema",
    "language": "Idioma",
    "collapse": "Contraer barra lateral",
    "expand": "Expandir barra lateral",
    "newConversation": "Nueva conversación",
    "dashboard": "Panel",
    "plans": "Planes Preventivos",
    "seed": {
      "dashboard": "Analizar la máquina ",
      "plans": "Listar los planes preventivos de "
    },
    "fallbackTitle": "Nueva conversación · {{time}}",
    "groups": {
      "today": "Hoy",
      "yesterday": "Ayer",
      "thisWeek": "Esta semana",
      "thisMonth": "Este mes",
      "earlier": "Anterior"
    }
  },
  "dashboard": {
    "title": "Indicadores de mantenimiento",
    "subtitle": "MTBF, MTTR, disponibilidad y backlog calculados en tiempo real.",
    "summary": "Resumen del tenant",
    "equipmentSeries": "Serie temporal por equipo",
    "equipmentTrend": "Tendencia de MTBF (últimos 6 meses)",
    "topFailureModes": "Top 5 modos de falla",
    "equipmentSelector": "Seleccionar equipo",
    "periodSelector": "Seleccionar período",
    "period": {
      "last30d": "Últimos 30 días",
      "last90d": "Últimos 90 días",
      "mtd": "Mes hasta hoy",
      "ytd": "Año hasta hoy"
    },
    "kpi": {
      "mtbf": {
        "label": "MTBF",
        "description": "Tiempo medio entre fallas, objetivo industrial > 100h."
      },
      "mttr": {
        "label": "MTTR",
        "description": "Tiempo medio de reparación, objetivo < 4h en mantenimiento correctivo."
      },
      "availability": {
        "label": "Disponibilidad",
        "description": "Uptime sobre la ventana analizada. Objetivo > 95%."
      },
      "backlog": {
        "label": "Backlog",
        "description": "OT abiertas aún sin concluir."
      }
    },
    "source": {
      "fallback": "OT fallback",
      "fallbackTooltip": "Calculado a partir de OT correctivas, Sprint C aún no habilitó el modelo Incident."
    },
    "empty": {
      "series": "Sin órdenes correctivas en el período para generar la serie.",
      "noEquipment": "Registra un equipo para visualizar la serie temporal."
    },
    "error": {
      "scopeRequired": "Equipo o planta obligatorio.",
      "loadFailed": "No se pudo cargar los datos. Intente de nuevo.",
      "retry": "Reintentar"
    },
    "card": {
      "openPlans": "Ver planes",
      "confidence": {
        "label": "Confianza",
        "high": "alta",
        "medium": "media",
        "low": "baja"
      },
      "export": {
        "xlsx": "Exportar Excel",
        "docx": "Exportar Word (.docx)",
        "generating": "Generando…",
        "error": "No se pudo generar el archivo. Inténtalo de nuevo.",
        "pdf": "Exportar PDF"
      },
      "plans": {
        "count_one": "{{count}} plan preventivo",
        "count_other": "{{count}} planes preventivos",
        "empty": "No se encontraron planes preventivos.",
        "openTasks": "Ver tareas",
        "searchPlaceholder": "Buscar plan o equipo",
        "viewSchedule": "Ver Cronograma",
        "noSearchResults": "Ningún plan coincide con la búsqueda."
      },
      "seed": {
        "setPeriod": "Analizar la máquina {{tag}} en el período {{period}}",
        "openPlans": "Listar los planes preventivos de {{tag}}",
        "planTasks": "Listar las tareas del plan {{plan}}"
      },
      "teams": {
        "title": "Equipos",
        "count_one": "{{count}} equipo registrado",
        "count_other": "{{count}} equipos registrados",
        "empty": "Aún no hay equipos registrados.",
        "col": {
          "name": "Equipo",
          "tag": "Código",
          "plant": "Planta",
          "specialty": "Especialidad",
          "technicians": "Técnicos"
        }
      },
      "materials": {
        "title": "Materiales",
        "count_one": "{{count}} material registrado",
        "count_other": "{{count}} materiales registrados",
        "empty": "Aún no hay materiales registrados.",
        "col": {
          "code": "Código",
          "description": "Descripción",
          "unit": "Unidad",
          "equipmentLinks": "Equipos"
        }
      },
      "notifications": {
        "title": "Notificaciones",
        "openCount_one": "{{count}} notificación abierta",
        "openCount_other": "{{count}} notificaciones abiertas",
        "matchedCount_one": "{{count}} en esta búsqueda",
        "matchedCount_other": "{{count}} en esta búsqueda",
        "pageRange": "Mostrando {{from}} a {{to}}",
        "empty": "No se encontraron notificaciones.",
        "col": {
          "number": "Número",
          "equipment": "Equipo",
          "type": "Tipo",
          "priority": "Prioridad",
          "status": "Estado",
          "actions": "Acciones",
          "detailing": "Detallado"
        },
        "status": {
          "open": "Abierta",
          "in_progress": "En curso",
          "closed": "Cerrada"
        },
        "type": {
          "M1": "Aviso de avería",
          "M2": "Aviso de mal funcionamiento",
          "M3": "Aviso de actividad"
        },
        "action": {
          "aria": "{{action}}: notificación {{number}}",
          "detail": "Detallar",
          "complete": "Completar detallado",
          "open": "Abrir OS"
        },
        "detailing": {
          "sem_os": "Sin orden",
          "incompleta": "Orden incompleta",
          "detalhada": "Orden detallada",
          "conflito": "Vínculo en conflicto",
          "bloqueada": "Detallado no disponible",
          "unknown": "Detallado no informado"
        },
        "missing": {
          "operation_description": "Descripción de la operación",
          "operation_team": "Equipo de la operación",
          "operation_specialty": "Especialidad de la operación",
          "planned_start": "Fecha planificada",
          "operation_duration": "Duración de la operación",
          "operation_duration_unit": "Unidad de duración",
          "operation_system_condition": "Condición de la instalación",
          "operations": "Operaciones",
          "unknown": "Información necesaria"
        }
      },
      "list": {
        "count_one": "{{count}} artículo",
        "count_other": "{{count}} artículos",
        "countTruncated_one": "Mostrando {{shown}} de {{count}} artículo",
        "countTruncated_other": "Mostrando {{shown}} de {{count}} artículos",
        "empty": "No se encontraron artículos.",
        "detail": {
          "show": "Ver detalles",
          "hide": "Ocultar detalles"
        },
        "action": {
          "header": "Acción",
          "execute": "Ejecutar"
        }
      }
    },
    "buildFooter": {
      "ariaLabel": "Información de versión del sistema",
      "label": "AxiomGO · v{{version}} · build {{sha}}"
    }
  },
  "plans": {
    "export": {"plan": "Plan", "equipment": "Equipo", "description": "Descripción", "strategy": "Estrategia", "interval": "Intervalo", "nextDue": "Próxima fecha", "tasks": "Tareas", "origin": "Origen del plan", "sequence": "Secuencia", "instruction": "Instrucción", "duration": "Duración (min)", "notRecorded": "No registrado", "plansSheet": "Planes", "tasksSheet": "Tareas",
      "units": {"days": "días", "hours": "horas", "km": "km", "cycles": "ciclos"},
      "origins": {"user": "Usuario", "ai_proposal": "Propuesta de IA", "ai_auto": "IA automática"}, "source": "Referencia de la fuente", "page": "Página", "citation": "Cita de la fuente", "grounding": "Fundamento", "groundingLabels": {"verified": "Cita verificada", "ai_unverified": "Sugerencia de IA no verificada"}},
    "cadence": {
      "unavailable": "Frecuencia no disponible",
      "notScheduledAutomatically": "Sin programación automática"
    },
    "activeOnly": "Activos",
    "inactiveOnly": "Inactivos",
    "allStatuses": "Todos",
    "allStrategies": "Todas las estrategias",
    "detailTitle": "Detalle del plan",
    "field": {
      "active": "Activo",
      "interval": "Intervalo",
      "origin": "Origen",
      "strategy": "Estrategia"
    },
    "filterPlaceholder": "Filtrar por etiqueta o número (PLA-…)",
    "noResults": "No se encontraron planes.",
    "statusFilterLabel": "Filtrar por estado",
    "strategyFilterLabel": "Filtrar por estrategia",
    "tasksEmpty": "Plan sin tareas, incompleto.",
    "tasksHeading": "Tareas",
    "bulk": {
      "trigger": "Activar planes inactivos ({{count}})",
      "groupLabel": "Activación de planes en lote",
      "reviewTitle_one": "¿Activar {{count}} plan inactivo de esta lista?",
      "reviewTitle_other": "¿Activar {{count}} planes inactivos de esta lista?",
      "reviewBody": "Cada plan pasa por la activación normal, con las mismas validaciones y permisos. Los planes ya activos no se modifican.",
      "confirm": "Confirmar activación",
      "cancel": "Cancelar",
      "progress": "Activando: {{done}} de {{total}}",
      "resultAll_one": "El plan fue activado.",
      "resultAll_other": "Los {{count}} planes fueron activados.",
      "resultMixed": "{{confirmed}} activados, {{refused}} rechazados, {{pending}} sin confirmar.",
      "refused": "{{tag}}: rechazado. {{reason}}",
      "pending": "{{tag}}: sin confirmar. Verifica antes de repetir.",
      "retry": "Verificar y reintentar ({{count}})",
      "dismiss": "Cerrar"
    },
    "title": "Planes Preventivos",
    "detailError": "No se pudo cargar el detalle del plan.",
    "tasksUnknown": "… tareas",
    "col": {
      "plan": "Plan",
      "equipment": "Equipo",
      "description": "Descripción",
      "interval": "Intervalo",
      "nextDue": "Próxima",
      "tasks": "Tareas"
    },
    "taskCount_zero": "0 tareas",
    "taskCount_one": "{{count}} tarea",
    "taskCount_other": "{{count}} tareas"
  },
  "horizon": {
    "title": "Horizonte preventivo (52 semanas)",
    "subtitle": "Planes activos por semana ISO. Solo lectura.",
    "empty": "No hay planes programados en el horizonte.",
    "weekDetail": "Semana {{week}}, {{count}} plan(es)"
  },
  "preventiveDue": {
    "title": "Planes preventivos por vencer",
    "summary": "{{count}} plan(es) por vencer en los próximos {{days}} días.",
    "cta": "Revisar y generar OT",
    "dismiss": "Descartar"
  },
  "engine": {
    "online": "Motor en línea",
    "offline": "Motor fuera de línea",
    "reconnecting": "Reconectando..."
  },
  "errors": {
    "connectionLost": "Conexión perdida. Reconectando...",
    "timeout": "El servidor no respondió a tiempo. Por favor, intenta de nuevo.",
    "generic": "Algo salió mal. Intenta de nuevo o contacta a soporte.",
    "invalidFormat": "Formato inválido. Revisa los datos e intenta de nuevo.",
    "sessionExpired": "Tu sesión expiró. Por favor, recarga la página.",
    "authError": "Sesión expirada. Inicia sesión de nuevo.",
    "sessionRenewing": "Reautenticando tu sesión…",
    "sessionRenewed": "Sesión renovada. Si tu última acción no avanzó, tócala de nuevo.",
    "permissionDenied": "Sin permiso para acceder a este recurso.",
    "rateLimited": "Demasiadas solicitudes. Espera unos segundos.",
    "networkBlocked": "No pudimos comunicarnos con el servidor. Revisa tu conexión e intenta de nuevo.",
    "streamFailed": "La respuesta se interrumpió. Toca \"Intentar de nuevo\" para reenviar.",
    "credentialTimeout": "No pude renovar tu credencial a tiempo. Revisa tu conexión y toca de nuevo.",
    "auth": {
      "invalidTenant": "Tenant inválido o ausente. Contacta al administrador de tu organización.",
      "providerUnavailable": "El proveedor de autenticación está temporalmente no disponible. Intenta de nuevo en unos instantes.",
      "notConfigured": "La autenticación no está configurada. Contacta al administrador del sistema.",
      "notApproved": "Solo cuentas aprobadas pueden acceder a la plataforma."
    },
    "stream": {
      "llmUnavailable": "El modelo de IA está temporalmente no disponible. Intenta de nuevo en unos segundos.",
      "turnDeadlineExceeded": "La conversación no respondió a tiempo y este turno se cerró. Envíalo de nuevo.",
      "requestUnconfirmed": "Aún no se pudo confirmar el resultado de la solicitud anterior. No iniciamos otra ejecución para evitar duplicados. Vuelve a abrir la conversación para revisar la respuesta antes de intentarlo de nuevo.",
      "internalError": "Algo salió mal en el motor. Intenta de nuevo o contacta a soporte."
    },
    "uniqueness": {
      "equipmentDuplicateTagInPlant": "El equipo con tag \"{{tag}}\" ya está registrado en la planta \"{{plantName}}\". Se reutilizará el registro existente.",
      "locationDuplicateCodeInPlant": "Ya existe una ubicación con código \"{{code}}\" en la planta \"{{plantName}}\". Usa otro código o elige una planta diferente.",
      "teamDuplicateNameInPlant": "Ya existe un equipo con nombre \"{{name}}\" en la planta \"{{plantName}}\". Usa otro nombre o elige una planta diferente.",
      "technicianDuplicatePersonnelNumberInTenant": "Ya existe un técnico con matrícula \"{{personnelNumber}}\" en este tenant. Usa otra matrícula."
    },
    "boundary": {
      "title": "Algo salió mal en esta parte de la pantalla",
      "message": "El resto de AxiomGO sigue funcionando. Recargue para intentar de nuevo.",
      "retry": "Recargar"
    },
    "loadRolesFailed": "No se pudieron cargar los perfiles de acceso.",
    "loadTeamFailed": "No se pudieron cargar los miembros del equipo."
  },
  "toasts": {
    "proposalApproved": "Propuesta aprobada con éxito",
    "proposalRejected": "Propuesta rechazada",
    "proposalAdjusted": "Propuesta ajustada",
    "engineReconnected": "Motor reconectado",
    "newConversation": "Nueva conversación iniciada",
    "themeChanged": "Tema cambiado",
    "importComplete": "Importación completada, {{count}} líneas",
    "importCompleteGeneric": "Importación completada",
    "importError": "Falla en la importación, toca para reintentar",
    "webSearchComplete": "Búsqueda completada",
    "copyConversationSuccess": "Conversación copiada",
    "voicePermissionLost": "Permiso de micrófono perdido. Usa el teclado.",
    "rateLimited": "Enviaste demasiados mensajes. Espera {{seconds}}s e intenta de nuevo.",
    "turnInFlight": "Espera a que termine la respuesta actual. Tu mensaje sigue en el campo, listo para enviarlo de nuevo.",
    "messageDropped": "Perdimos parte de la respuesta del sistema. Si la pantalla parece congelada, recarga la página."
  },
  "proposal": {
    "approve": "Aprobar",
    "adjust": "Ajustar",
    "reject": "Rechazar",
    "confidence": "Confianza"
  },
  "files": {
    "download": "Descargar",
    "attach": "Adjuntar archivo",
    "camera": "Cámara",
    "capturePhoto": "Tomar foto",
    "photoAttachment": "Foto",
    "cameraNativePermissionDenied": "Acceso a la cámara denegado. Permite el acceso en la configuración de la aplicación e intenta de nuevo.",
    "cameraUnavailable": "La cámara no está disponible en este dispositivo.",
    "cameraCaptureFailed": "No se pudo capturar o leer la foto. Intenta de nuevo.",
    "cameraPermissionDenied": "El acceso a la cámara fue denegado. Permite el acceso a la cámara en la configuración del navegador e intenta de nuevo.",
    "unsupportedFormat": "\"{{filename}}\" no es un formato compatible.",
    "fileTooLarge": "\"{{filename}}\" es demasiado grande. Tamaño máximo 50MB (20MB para imágenes).",
    "tooManyFiles": "Máximo 5 archivos por mensaje.",
    "types": {
      "spreadsheet": "Planilla",
      "csv": "CSV",
      "pdf": "PDF",
      "document": "Documento",
      "image": "Imagen",
      "text": "Texto",
      "generic": "Archivo"
    },
    "uploadFailed": "Falla al enviar el archivo. Intenta de nuevo.",
    "attachmentContextChanged": "Cambió el contexto del adjunto. Selecciona el archivo otra vez antes de enviar.",
    "uploadTenantMissing": "Sesión sin tenant. Inicia sesión de nuevo.",
    "uploading": "Enviando archivo...",
    "gallery": "Galería",
    "uploadFailedStatus": "Error al enviar el archivo (error {{status}}). Inténtalo de nuevo.",
    "uploadMissingFileId": "El servidor recibió el archivo pero no devolvió el identificador. Inténtalo de nuevo.",
    "durableAttachmentsDisabled": "No se puede enviar \"{{filename}}\" ahora (los archivos grandes de este tipo aún no están habilitados). Intenta con un archivo más pequeño o espera a que se habilite."
  },
  "processing": {
    "default": "Procesando..."
  },
  "form": {
    "submit": "Enviar",
    "submitted": "Datos enviados"
  },
  "validation": {
    "tagFormat": "Formato incorrecto. Ejemplo: BOM-2201A",
    "notaFormat": "Formato incorrecto. Ingresa 8 a 10 dígitos.",
    "ordemFormat": "Formato incorrecto. Ingresa 7 a 12 dígitos.",
    "currencyInvalid": "Valor monetario inválido.",
    "currencyNegative": "El valor no puede ser negativo.",
    "dateInvalid": "Fecha inválida. Verifica el formato."
  },
  "input": {
    "quickActions": "Acciones rápidas",
    "suggestionsAvailable": "{{count}} sugerencias disponibles",
    "chatAriaLabel": "Campo de mensaje del chat"
  },
  "conversation": {
    "delete": {
      "confirm": "¿Eliminar esta conversación? Esta acción no se puede deshacer.",
      "button": "Eliminar"
    },
    "empty": {
      "title": "Su planta, orquestada.",
      "subtitle": "Del registro al plan preventivo, de la falla a la orden de trabajo concluida: AxiomGO conduce cada etapa con usted.",
      "cta": "Nueva conversación"
    },
    "untitled": "Conversación sin título",
    "edit": {
      "placeholder": "Nombre de la conversación",
      "title": "Editar el nombre de la conversación"
    },
    "rename": "Renombrar",
    "menu": "Más opciones"
  },
  "import": {
    "analyzeFailed": "Falla al analizar la planilla. Intenta de nuevo.",
    "executeFailed": "Falla al ejecutar la importación. No se importó nada. Verifica tu conexión e intenta de nuevo.",
    "proposal": {
      "title": "Importación: {{fileName}}",
      "rows": "{{count}} líneas",
      "columns": "{{count}} columnas",
      "entity": "Entidad detectada: {{entity}}",
      "unmapped": "{{count}} columnas sin mapear",
      "issues": "{{count}} problemas detectados",
      "confirm": "Importar con este mapeo",
      "confirmWithId": "Confirmo la importación de la propuesta {{proposalId}} con los mapeos mostrados.",
      "adjust": "Ajustar mapeo",
      "cancel": "Cancelar",
      "adjustPlaceholder": "Describe los ajustes deseados (ej.: \"XPTO es el número de patrimonio\")",
      "table": {
        "source": "Tu columna",
        "target": "Campo AxiomGO",
        "confidence": "Conf.",
        "sample": "Muestra"
      },
      "processing": "Procesando..."
    },
    "progress": {
      "title": "Importando {{entity}}...",
      "enqueued": "Importación de {{entity}} en cola",
      "completed": "Importación de {{entity}} completada",
      "failed": "Importación de {{entity}} falló",
      "records": "{{processed}} / {{total}} registros",
      "imported": "{{count}} importados",
      "skipped": "{{count}} omitidos",
      "errors": "{{count}} errores",
      "eta": "Tiempo estimado: ~{{time}}",
      "completedWithErrors": "Importación de {{entity}} concluida con fallas"
    },
    "report": {
      "success": "¡Importación completada!",
      "failure": "Importación falló",
      "imported": "{{count}} {{entity}} importados",
      "autocreated": "{{count}} dependencias creadas",
      "skipped": "{{count}} duplicados omitidos",
      "errors": "{{count}} líneas con error",
      "duration": "Duración: {{time}}",
      "download": "Descargar reporte de errores"
    },
    "validation": {
      "title": "Validación completa",
      "valid": "{{count}} líneas válidas",
      "errors": "{{count}} líneas con error",
      "warnings": "{{count}} advertencias",
      "missingTitle": "Dependencias faltantes:",
      "missing": "{{count}} {{entity}} no encontrados",
      "duplicates": "{{count}} registros ya existen",
      "importAnyway": "Importar de todos modos",
      "createAndImport": "Crear dependencias e importar",
      "processing": "Procesando..."
    },
    "entity": {
      "Equipment": "Equipos",
      "Location": "Ubicaciones",
      "Plant": "Plantas",
      "Material": "Materiales",
      "MaintPlan": "Planes de mantenimiento",
      "WorkOrder": "Órdenes de trabajo",
      "Team": "Equipos de trabajo",
      "Technician": "Técnicos",
      "Notification": "Notificaciones",
      "Supplier": "Proveedores",
      "Specialty": "Especialidades"
    },
    "templateOffer": {
      "title": "¿Aún no tienes plantilla?",
      "subtitle": "Descarga un modelo Excel listo para completar y enviar.",
      "levelLabel": "Modelo:",
      "levelBasic": "Básico (campos obligatorios)",
      "levelFull": "Completo (todos los campos)",
      "langLabel": "Idioma:",
      "downloadAll": "Descargar todo (.zip)",
      "downloadingAll": "Generando paquete...",
      "error": "Falla al descargar plantilla: {{msg}}"
    },
    "dropzone": {
      "text": "Suelta el archivo para importar",
      "unsupported": "Formato no compatible. Usa .xlsx, .xls o .csv",
      "uploading": "Enviando...",
      "analyzing": "Analizando...",
      "sent": "Enviado"
    },
    "file": {
      "size": {
        "kb": "{{size}} KB",
        "mb": "{{size}} MB"
      },
      "rows": "{{count}} líneas",
      "sheets": "{{count}} pestañas"
    },
    "detection": {
      "detected": "Planilla identificada como {{entity}} ({{confidence}}% de confianza)",
      "lowConfidence": "No pude identificar el tipo de datos con certeza. Parece ser {{entity}}, ¿confirmas?",
      "unknown": "No reconocí el tipo de datos. ¿Puedes decirme qué contiene esta planilla?",
      "learned": "Reconocí este formato de importaciones anteriores",
      "profileAutoApplied": "Perfil aprendido aplicado automáticamente"
    },
    "defaults": {
      "applied": "{{field}} definido como {{value}} ({{standard}})",
      "criticality_b": "Criticidad B aplicada, estándar ISO 55001 para activos sin clasificación"
    },
    "dependencies": {
      "willCreate": "{{entity}} '{{name}}' se creará automáticamente",
      "created": "{{entity}} '{{name}}' creado con éxito",
      "failed": "No fue posible crear {{entity}} '{{name}}': {{reason}}"
    },
    "template": {
      "askEntity": "¿Para qué tipo de dato necesitas la plantilla?",
      "generating": "Generando plantilla de {{entity}}...",
      "ready": "¡Plantilla de {{entity}} lista!",
      "downloadHint": "Descarga, completa y envía de vuelta para importar.",
      "requiredColumns": "Columnas obligatorias: {{columns}}",
      "exampleIncluded": "Incluí un ejemplo real de tu base de datos."
    },
    "webSearch": {
      "consultedWeb": "Búsqueda web realizada",
      "dataFrom": "Con base en el manual del fabricante",
      "maintenancePlan": "Plan de mantenimiento preventivo",
      "manufacturer": "Fabricante",
      "model": "Modelo",
      "equipmentType": "Tipo",
      "viewSources": "Ver fuentes ({{count}})",
      "hideSources": "Ocultar fuentes",
      "importOffer": "¿Deseas importar el plan preventivo?",
      "importTasks_zero": "{{count}} tareas",
      "importTasks_one": "{{count}} tarea",
      "importTasks_other": "{{count}} tareas",
      "importYes": "Sí, importar",
      "importInfo": "Solo quiero la info",
      "importStarted": "Importación iniciada",
      "infoOnly": "Ok, mantengo solo la información",
      "confidence": "confianza",
      "cached": "datos en caché",
      "cachedAgo": "de hace {{time}}"
    },
    "webSearchCard": {
      "plan": {
        "period": {
          "horas": "HORAS",
          "diario": "DIARIO",
          "semanal": "SEMANAL",
          "mensal": "MENSUAL",
          "anual": "ANUAL",
          "ciclos": "CICLOS",
          "naoEspecificado": "NO ESPECIFICADO"
        },
        "totals": "TOTALES DEL PLAN",
        "importQuestion": "¿Deseas importar el plan preventivo?",
        "importYes": "Sí, importar",
        "importInfoOnly": "Solo quiero la info",
        "seeDetails": "ver detalles",
        "hideDetails": "ocultar detalles",
        "technicianNotSpecified": "No especificado"
      }
    },
    "multiSheet": {
      "analysisTitle": "Analicé tu planilla \"{{fileName}}\"",
      "sheetsFound": "{{count}} pestaña(s) encontrada(s)",
      "rowCount": "{{count}} registros",
      "unrecognizedSheet": "Pestaña no reconocida, será ignorada",
      "unmapped": "Sin correspondencia",
      "colExcel": "Columna",
      "colCmms": "Campo AxiomGO",
      "colConfidence": "Conf.",
      "colSheet": "Pestaña",
      "colEntity": "Entidad",
      "approveAll": "Importar todo",
      "reviewDependencies": "Revisar dependencias",
      "cancel": "Cancelar",
      "dependenciesTitle": "Dependencias sin registrar",
      "dependenciesCount": "{{count}} ítem(s) necesitan ser creados",
      "selectAll": "Seleccionar todos",
      "createAndImport": "Crear seleccionados e importar",
      "skipAndImport": "Omitir e importar sin crear",
      "noAutoCreate": "No se puede crear automáticamente",
      "registerPlantFirst": "Registre la planta primero",
      "registerViaChatFirst": "Regístrelo por el chat antes de importar",
      "readyToImport": "Listo para importar",
      "recordsSummary": "{{records}} registros en {{sheets}} pestañas",
      "depsToCreate": "+ {{count}} ítems por crear",
      "importOrder": "Orden de importación",
      "executeImport": "Ejecutar importación",
      "back": "Volver",
      "importing": "Importando {{entity}}...",
      "importingSheet": "Pestaña \"{{sheet}}\" ({{current}}/{{total}})",
      "completed": "Importación completada",
      "partial": "Importación parcial",
      "failed": "Importación falló",
      "duration": "Completado en {{seconds}}s",
      "created": "Creados",
      "updated": "Actualizados",
      "skipped": "Omitidos",
      "errors": "Errores",
      "rowError": "Línea {{row}}: {{message}}",
      "reasonMissing": "La importación falló y la respuesta no trajo el motivo. Descargue el informe de errores o envíe la planilla de nuevo.",
      "nothingExecutable": "Ninguna hoja está habilitada para importar. Las hojas reconocidas con confianza parcial necesitan su confirmación antes de grabar cualquier fila."
    },
    "job": {
      "title": "Importación en curso",
      "titleCompleted": "Importación completada",
      "titleCompletedWithErrors": "Importación completada con fallas",
      "correctionsApplied": "Correcciones aplicadas",
      "correctionsPartial": "Correcciones aplicadas parcialmente",
      "initialProcessing": "Procesamiento inicial:",
      "titleFailed": "La importación falló",
      "titleCanceled": "Importación cancelada",
      "titleStalled": "Importación sin respuesta",
      "state": {
        "pending": "Esperando inicio",
        "enqueued": "En cola",
        "running": "Importando...",
        "completed": "Completado",
        "failed": "Falló",
        "canceled": "Cancelado",
        "stalled": "Sin respuesta",
        "completed_with_errors": "Concluido con fallas"
      },
      "stalled": {
        "title": "Importación sin respuesta",
        "body": "No recibimos actualización del servidor. La importación puede seguir en curso o haberse detenido.",
        "checkNow": "Verificar ahora",
        "dismiss": "Descartar"
      },
      "imported": "Importadas",
      "skipped": "Omitidas",
      "errors": "Errores",
      "failedRows": "Líneas con falla",
      "currentSheet": "Pestaña actual",
      "duration": "Duración: {{seconds}} s",
      "viewFailedRows": "Ver líneas con falla",
      "viewSkippedRows": "Ver líneas omitidas",
      "errorMessage": "Mensaje de error: {{message}}",
      "skippedSheets_one": "{{count}} hoja no reconocida: {{names}}",
      "skippedSheets_other": "{{count}} hojas no reconocidas: {{names}}",
      "fixedActions": {
        "openCorrectiveOrder": "Abrir OT Correctiva",
        "generateMaintenancePlan": "Generar plan de mantenimiento",
        "viewMyEquipment": "Ver mis equipos"
      },
      "viewSkippedRows": "Ver filas omitidas"
    },
    "pendingSheet": {
      "title": "Hojas esperando su confirmación:",
      "row": "{{sheet}}: parece {{entity}} ({{rows}} filas)",
      "accept": "Importar como {{entity}}",
      "ignore": "Ignorar esta hoja",
      "accepted": "Hoja confirmada. La importación fue encolada.",
      "ignored": "Hoja ignorada. Nada fue importado de ella.",
      "failed": "No fue posible registrar la decisión. Intente de nuevo."
    },
    "failedRows": {
      "title": "Líneas con falla ({{count}})",
      "colRow": "Línea",
      "colSheet": "Pestaña",
      "colField": "Campo",
      "colReason": "Motivo",
      "loading": "Cargando...",
      "empty": "Ningún detalle disponible para este job.",
      "loadError": "No fue posible cargar las líneas con falla. Intente de nuevo.",
      "retry": "Intentar de nuevo",
      "prev": "← Anterior",
      "next": "Siguiente →",
      "download": "Descargar informe de errores",
      "close": "Cerrar",
      "colCorrecao": "Corrección",
      "escolha": "Elija...",
      "semTipoConhecido": "Corrija en la planilla e importe de nuevo",
      "corrigirCampo": "Corregir {{campo}}",
      "cadastreDependencia": "Registre {{entidade}} antes de reenviar esta fila",
      "reenviar": "Reimportar {{count}} fila(s) corregida(s)",
      "reenviando": "Reimportando...",
      "linhaCorrigida": "Corregida",
      "linhaFalhou": "Aún con falla",
      "contagem": "{{total}} fallas → {{corrigidas}} corregidas → {{pendentes}} pendientes",
      "erroVazio": "Complete este campo",
      "erroNumero": "Use un número",
      "erroData": "La fecha no existe",
      "erroOpcao": "Elija uno de los valores de la lista",
      "erroBooleano": "Use sí o no",
      "erroSemTipo": "Este campo no se puede corregir aquí",
      "erroAoReenviar": "No pude reimportar las filas. Intente de nuevo.",
      "valorQueVeio": "Vino: {{valor}}"
    },
    "skippedRows": {
      "title": "Líneas omitidas ({{count}})",
      "colRow": "Línea",
      "colSheet": "Pestaña",
      "colReason": "Motivo",
      "loading": "Cargando...",
      "empty": "No se omitió ninguna línea en esta importación.",
      "loadError": "No se pudieron cargar las líneas omitidas. Intente de nuevo.",
      "retry": "Intentar de nuevo",
      "prev": "← Anterior",
      "next": "Siguiente →",
      "close": "Cerrar",
      "reason": {
        "duplicate": "Línea duplicada",
        "no_match": "La línea no coincide con ningún registro",
        "other": "Motivo no clasificado por el sistema"
      },
      "reasonFallback": "Línea no reconocida. Revise los datos de esta línea."
    },
    "inlineForm": {
      "code": "Código",
      "codeExemplo": "PL-02",
      "name": "Nombre",
      "nameExemplo": "Planta Piracicaba",
      "country": "País (2 letras)",
      "countryExemplo": "BR",
      "timezone": "Zona horaria",
      "timezoneExemplo": "America/Sao_Paulo",
      "erroObrigatorio": "Complete este campo",
      "erroPais": "Use la sigla de 2 letras del país, como BR",
      "erroFuso": "La zona horaria no existe. Use el formato America/Sao_Paulo",
      "erroAoCriar": "No pude crear el registro. Intente de nuevo.",
      "criando": "Creando registro..."
    },
    "skippedRows": {
      "close": "Cerrar",
      "colReason": "Motivo",
      "colRow": "Fila",
      "colSheet": "Hoja",
      "empty": "No se omitió ninguna fila en esta importación.",
      "loadError": "No se pudieron cargar las filas omitidas. Inténtalo de nuevo.",
      "loading": "Cargando...",
      "next": "Siguiente →",
      "prev": "← Anterior",
      "reason": {
        "duplicate": "Fila duplicada",
        "no_match": "La fila no coincide con ningún registro",
        "other": "Motivo no clasificado por el sistema"
      },
      "reasonFallback": "No se reconoció la fila. Revisa sus datos.",
      "retry": "Intentar de nuevo",
      "title": "Filas omitidas ({{count}})"
    }
  },
  "search": {
    "webIndicator": "Consulté la web · sugerencia con base en el manual {{manufacturer}}",
    "webIndicatorCached": "(datos en caché de hace {{hours}}h)",
    "viewDetails": "Ver detalles completos",
    "hideDetails": "Ocultar detalles",
    "viewSources": "Ver fuentes ({{count}})",
    "hideSources": "Ocultar fuentes",
    "sourcesTitle": "Fuentes consultadas",
    "importOffer": "¿Deseas registrar esta sugerencia de plan preventivo para {{tag}}?",
    "importTaskCount": "Se crearán {{count}} tareas con los intervalos sugeridos. Revise antes de aplicar.",
    "importYes": "Sí, importar",
    "importNo": "No, solo quiero la info",
    "importSuccess_zero": "Sugerencia revisada y registrada: plan preventivo con {{count}} tareas. Próxima {{task}}: {{date}}.",
    "importSuccess_one": "Sugerencia revisada y registrada: plan preventivo con {{count}} tarea. Próxima {{task}}: {{date}}.",
    "importSuccess_other": "Sugerencia revisada y registrada: plan preventivo con {{count}} tareas. Próxima {{task}}: {{date}}.",
    "importSuccessNoNext_zero": "Sugerencia revisada y registrada: plan preventivo con {{count}} tareas.",
    "importSuccessNoNext_one": "Sugerencia revisada y registrada: plan preventivo con {{count}} tarea.",
    "importSuccessNoNext_other": "Sugerencia revisada y registrada: plan preventivo con {{count}} tareas.",
    "importPending": "Importando el plan preventivo. Esperando la confirmación del motor.",
    "importStillProcessing": "La importación sigue en proceso. La confirmación aparece aquí en la conversación apenas termine.",
    "importFailedTitle": "No pude importar el plan preventivo.",
    "importError": "Vuelve a la conversación y pídeme importar el plan otra vez.",
    "confidenceHigh": "confianza alta",
    "confidenceMedium": "confianza media",
    "confidenceLow": "confianza baja",
    "noResults": "No encontré datos del fabricante {{manufacturer}} en la web."
  },
  "webSearch": {
    "consultedWeb": "Consulté la web",
    "dataFrom": "sugerencia con base en el manual del fabricante",
    "headerLabel": "Consulté la web · sugerencia con base en el manual del fabricante",
    "headerLabelLibrary": "Vino de la Biblioteca · {{when}}",
    "headerLabelManual": "Leí el manual adjunto · sugerencia con base en el manual",
    "headerLabelNeutral": "Búsqueda web",
    "maintenancePlan": "Plan de mantenimiento preventivo",
    "preventivePlanLabel": "Plan preventivo",
    "planTotals": "Totales del plan",
    "manufacturer": "Fabricante",
    "model": "Modelo",
    "equipmentType": "Tipo",
    "viewSources": "Ver fuentes ({{count}})",
    "hideSources": "Ocultar fuentes",
    "importOffer": "¿Deseas importar el plan preventivo?",
    "importTasks_zero": "{{count}} tareas",
    "importTasks_one": "{{count}} tarea",
    "importTasks_other": "{{count}} tareas",
    "importYes": "Sí, importar",
    "importInfo": "Solo quiero la info",
    "importStarted": "Importación iniciada",
    "infoOnly": "Ok, mantengo solo la información",
    "confidence": {
      "badgeLabel": "{{pct}}%",
      "noData": "sin datos",
      "tooltip": "Confianza {{pct}}%, {{chunks}} chunks de {{urls}} URL",
      "noDataTooltip": "Datos de confianza no disponibles"
    },
    "cached": "datos en caché",
    "cachedAgo": "de hace {{time}}",
    "taskCount_zero": "{{count}} tareas",
    "taskCount_one": "{{count}} tarea",
    "taskCount_other": "{{count}} tareas",
    "durationEstimated": "(est.)",
    "materialsLabel": "Materiales",
    "toolsLabel": "Herramientas",
    "lubricantLabel": "Lubricante",
    "workTypeLabel": "Disciplina",
    "peopleRequiredLabel": "Cuadrilla",
    "peopleRequiredValue_one": "{{count}} persona",
    "peopleRequiredValue_other": "{{count}} personas",
    "noPlanFound": "No encontré plan específico para {{manufacturer}} {{model}}. Puedes:",
    "openManual": "Buscar manual en el fabricante",
    "registerManually": "Registrar este equipo",
    "usualPlanDisclaimer": "No encontramos el manual del equipo, pero inferimos un plan siguiendo las prácticas del mercado.",
    "headerInferred": "Consulté la web · sugerencia con base en equipo similar",
    "headerMarketPractice": "Consulté la web · sugerencia con base en prácticas de la clase y normas",
    "inferredDisclaimer": "No encontramos el manual del {{manufacturer}} {{model}}, pero inferimos un plan siguiendo las prácticas del mercado.",
    "registerEquipmentCta": "Registrar este equipo",
    "montarPlanoPreventivo": "Armar el Plan Preventivo",
    "refineSearch": "Refinar búsqueda",
    "unavailable": {
      "title": "Investigación de plan",
      "body": "El servicio de investigación de planes no está disponible en este momento."
    },
    "noSources": {
      "title": "No se encontraron fuentes",
      "body": "No encontré fuentes en la web para {{manufacturer}} {{model}}. Puedes registrar el equipo manualmente.",
      "retry": "Intentar de nuevo",
      "registerManually": "Registrar este equipo"
    },
    "workType": {
      "electrical": "Eléctrica",
      "mechanical": "Mecánica",
      "instrumentation": "Instrumentación",
      "hydraulic": "Hidráulica",
      "pneumatic": "Neumática",
      "lubrication": "Lubricación",
      "civil": "Civil",
      "inspection": "Inspección",
      "other": "Otro"
    },
    "lowConfidenceTitle": "Baja confianza",
    "lowConfidenceHint": "Confirma con el manual del fabricante antes de aplicar.",
    "notRegisteredTitle": "Equipo no registrado",
    "notRegisteredBody": "No encontré {{manufacturer}} {{model}} en tu registro. ¿Puedo crear el equipo y ya importar las {{count}} tareas del plan preventivo?",
    "confirmCreateAndImport": "Crear e importar",
    "creatingAndImporting": "Creando equipo e importando plan...",
    "createCancelled": "Ok, mantengo solo la información del fabricante.",
    "plan": {
      "presentation": {
        "pendingField": "Traducción pendiente",
        "unavailableField": "Traducción no disponible",
        "pending": "Preparando traducción del plan…",
        "unavailable": "Traducción del plan no disponible. El plan aún no está completamente traducido.",
        "retry": "Reintentar traducción",
        "original": "Mostrar fuente original (idioma de origen)"
      },
      "headers": {
        "task": "Tarea",
        "criticality": "Crít.",
        "period": "Período",
        "technician": "Técnico",
        "materials": "Materiales",
        "tools": "Herramientas",
        "time": "Tiempo",
        "citations": "Fuentes",
        "timeDecimal": "Horas decimales",
        "procedure": "Procedimiento"
      },
      "export": {
        "title": "AxiomGO: Plan de mantenimiento",
        "sheetName": "Plan de mantenimiento",
        "equipmentLabel": "Equipo",
        "typeLabel": "Tipo",
        "noticeLabel": "Aviso",
        "inferredDisclaimer": "Plan usual (estimación), NO es del fabricante. Generado a partir de equipos similares. Valide antes de ejecutar.",
        "proceduresTitle": "Procedimientos"
      },
      "criticality": {
        "A": "Crítico A",
        "B": "Grado B",
        "C": "Grado C",
        "inferred": "Inferido por la IA"
      },
      "unit": {
        "DAYS_one": "{{count}} día",
        "DAYS_other": "{{count}} días",
        "WEEKS_one": "{{count}} semana",
        "WEEKS_other": "{{count}} semanas",
        "MONTHS_one": "{{count}} mes",
        "MONTHS_other": "{{count}} meses",
        "YEARS_one": "{{count}} año",
        "YEARS_other": "{{count}} años",
        "CYCLES_one": "{{count}} ciclo",
        "CYCLES_other": "{{count}} ciclos"
      },
      "skill": {
        "mechanical": "Mecánico",
        "electrical": "Electricista",
        "instrumentation": "Instrumentista",
        "lubrication": "Lubricación",
        "inspection": "Inspección",
        "general": "General",
        "operator": "Operador"
      },
      "cert": {
        "NR-10": "NR-10",
        "NR-13": "NR-13"
      },
      "toolType": {
        "mechanical": "Mecánica",
        "electrical": "Eléctrica",
        "measurement": "Medición",
        "safety": "EPP/Seguridad",
        "lifting": "Izaje",
        "other": "Otro"
      },
      "oemLabel": "OEM",
      "nonOemLabel": "NO-OEM",
      "band": {
        "por_turno": "Por turno",
        "diaria": "Diaria",
        "semanal": "Semanal",
        "mensal": "Mensual",
        "trimestral": "Trimestral",
        "semestral": "Semestral",
        "anual": "Anual",
        "por_hora_operacao": "Por hora de operación",
        "por_condicao": "Según condición"
      },
      "noCadence": "Sin cadencia declarada",
      "triggers": {
        "pair": "{{a}} o {{b}}",
        "anyFirst": "lo que ocurra primero",
        "firstService": "Primer servicio: {{x}}"
      },
      "expandSteps": "Expandir pasos",
      "importButton": "Importar plan de mantenimiento",
      "exportLabel": "Exportar",
      "exportXlsx": "Excel (.xlsx)",
      "exportDocx": "Word (.docx)",
      "exportPreparing": "Preparando archivo…",
      "exportTimeout": "La preparación del archivo superó el tiempo límite. No se generó ningún archivo. Haz clic en Excel o Word para volver a intentarlo.",
      "exportError": "No se pudo generar el archivo. Inténtalo de nuevo.",
      "exportTranslationUnavailable": "No se pudo traducir todo el plan al idioma seleccionado. No se generó ningún archivo. Inténtalo de nuevo cuando la traducción esté disponible.",
      "import": {
        "disabled": "El plan no cumple criterios mínimos. Refina la búsqueda o registra manualmente."
      },
      "confidence": {
        "overall": "Confianza general",
        "by_dimension": {
          "period": "Período",
          "technician": "Técnico",
          "materials": "Materiales",
          "tools": "Herramientas",
          "duration": "Tiempo"
        }
      },
      "citation": {
        "title": "Fuentes de esta tarea"
      },
      "equipmentTypeName": {
        "air_compressor": "Compresor de aire",
        "boiler": "Caldera",
        "centrifugal_pump": "Bomba centrífuga",
        "conveyor_belt": "Cinta transportadora",
        "cooling_tower": "Torre de enfriamiento",
        "diesel_generator": "Generador diésel",
        "electric_motor": "Motor eléctrico",
        "forklift": "Montacargas",
        "heat_exchanger": "Intercambiador de calor",
        "hydraulic_press": "Prensa hidráulica",
        "industrial_fan": "Ventilador industrial",
        "overhead_crane": "Puente grúa",
        "reciprocating_compressor": "Compresor alternativo",
        "rotary_screw_compressor": "Compresor de tornillo rotativo",
        "screw_compressor": "Compresor de tornillo",
        "vacuum_pump": "Bomba de vacío"
      },
      "procedureOrigin": "Procedimiento por {{origin}}, no del fabricante",
      "aiFooter": "Sugerencia generada por IA a partir de las fuentes citadas. Revise antes de aplicar: la decisión final es del responsable técnico.",
      "provenanceTier": {
        "pratica_setor": "práctica del sector",
        "analogia": "analogía",
        "inferencia": "inferencia",
        "norma": "norma técnica"
      },
      "tasksOmitted_one": "{{count}} tarea del plan no está en esta tabla: el plan superó el techo del motor.",
      "tasksOmitted_other": "{{count}} tareas del plan no están en esta tabla: el plan superó el techo del motor."
    },
    "rawFindingsHeading": "Hallazgos del manual",
    "rawFindingsHint": "Evidencias textuales extraídas de las fuentes (no estructuradas)",
    "v2": {
      "empty": "No fue posible estructurar un plan de mantenimiento a partir de las fuentes disponibles.",
      "degraded": "No fue posible estructurar un plan completo. Hallazgos manuales extraídos de las fuentes:",
      "findingsTitle": "Hallazgos de mantenimiento brutos"
    },
    "cache": {
      "hitChip": "resultado de hace {{ago}}",
      "refresh": "Actualizar",
      "refreshAria": "Actualizar resultado, buscar datos nuevos ignorando el caché"
    },
    "debug": {
      "pipelineCounters": "Telemetría del embudo (admin)",
      "counterKey": "Etapa",
      "counterValue": "Conteo"
    }
  },
  "preventivePlan": {
    "title": "Plan Preventivo, borrador",
    "empty": "Sin tareas. Agregue al menos una para guardar el borrador.",
    "headers": {
      "task": "Tarea",
      "frequency": "Frecuencia",
      "specialty": "Especialidad",
      "cycleStart": "Inicio de ciclo",
      "actions": "Acciones"
    },
    "unit": {
      "hours": "horas",
      "days": "días",
      "weeks": "semanas",
      "months": "meses"
    },
    "specialty": {
      "mechanical": "Mecánica",
      "electrical": "Eléctrica",
      "instrumentation": "Instrumentación",
      "lubrication": "Lubricación",
      "inspection": "Inspección",
      "general": "General"
    },
    "daysHint": "≈ {{days}}d",
    "addRow": "+ Agregar tarea",
    "saveDraft": "Guardar Borrador",
    "deleteRow": "Eliminar fila",
    "placeholderWarning": "Cadencia estimada: revise antes de guardar.",
    "entryCard": {
      "title": "¿Cómo quieres crear el plan preventivo?",
      "whichEquipment": "¿Para qué equipo es el plan?",
      "registerEquipment": "Registrar equipo",
      "import": "Importar",
      "webSearch": "Buscar en la Web",
      "manual": "Registrar Manualmente"
    },
    "manualStartHint": "Agrega cada tarea: qué hacer, cada cuántos días, qué especialidad y qué materiales. Empieza por la primera.",
    "addRowHint": "Consejo: nómbrala por el verbo, 'Cambiar', 'Inspeccionar', 'Lubricar'.",
    "confirmText": "Plan(es) guardados como borrador (inactivos). Actívalos cuando quieras que entren en la programación.",
    "guidance": {
      "noTeam": "Ningún equipo registrado. ¿Deseas crear un equipo predeterminado?",
      "createDefaultTeam": "Crear equipo predeterminado",
      "missingMaterial": "Algunos materiales no existen en el inventario. ¿Deseas registrarlos ahora?",
      "registerMaterials": "Registrar materiales"
    },
    "suggestion": {
      "title": "Sugerencia: armar plan preventivo",
      "withoutPlanSuffix": "equipos sin plan preventivo",
      "startA": "Empezar por los A (críticos)",
      "startB": "Empezar por los B",
      "startC": "Empezar por los C",
      "manual": "Armar manualmente",
      "dismiss": "No recordarme por 7 días",
      "close": "Cerrar recordatorio",
      "headline_one": "1 equipo crítico ({{criticality}}) sin plan preventivo",
      "headline_other": "{{count}} equipos críticos ({{criticality}}) sin plan preventivo"
    },
    "suggestionBell": {
      "aria": "Sugerencias de plan preventivo",
      "withoutActivePlan_one": "equipo sin plan preventivo",
      "withoutActivePlan_other": "equipos sin plan preventivo",
      "draftsAwaitingApproval_one": "borrador esperando aprobación",
      "draftsAwaitingApproval_other": "borradores esperando aprobación"
    }
  },
  "execution": {
    "confirmed": "Confirmado en el sistema",
    "partial": "Registrado parcialmente",
    "failure": "No registrado en el sistema",
    "mismatch": "Lo que se registró difiere de lo solicitado. Revise los elementos a continuación.",
    "summary": "{{created}} creados · {{failed}} fallidos",
    "status": {
      "created": "Creado",
      "failed": "Falló"
    },
    "entity": {
      "work_order": "Órdenes de trabajo",
      "equipment": "Equipos",
      "location": "Ubicaciones",
      "maintenance_plan": "Planes de mantenimiento",
      "part": "Repuestos",
      "goods_receipt": "Recepciones",
      "notification": "Notificaciones"
    }
  },
  "teamTechnicianBatchReceipt": {
    "title": "Técnicos registrados",
    "badge": {
      "saved": "GUARDADO",
      "partial": "{{saved}} DE {{total}} GUARDADOS"
    },
    "status": {
      "saved": "guardado"
    },
    "summary": "{{technicians}} técnicos · {{teams}} equipos creados"
  },
  "entityCard": {
    "entity": {
      "WorkOrder": "Orden de trabajo",
      "Notification": "Notificación",
      "WoOperation": "Operación",
      "WoComponent": "Componente",
      "MaterialDocument": "Documento de material",
      "Proposal": "Propuesta",
      "Equipment": "Equipo",
      "Location": "Ubicación",
      "Plant": "Planta",
      "Material": "Material",
      "Team": "Equipo de trabajo",
      "Technician": "Técnico",
      "MaintPlan": "Plan de mantenimiento",
      "MaintTaskList": "Lista de tareas",
      "MaintTaskListOperation": "Operación de la lista",
      "MaintTaskListComponent": "Componente de la lista",
      "MaintenanceItem": "Ítem de mantenimiento",
      "MaintenanceCycle": "Ciclo de mantenimiento",
      "LtpScenario": "Escenario",
      "rotary_screw_compressor": "Compresor de tornillo rotativo",
      "unknown": "Equipo"
    },
    "field": {
      "businessId": "Identificador",
      "description": "Descripción técnica",
      "status": "Estado",
      "origin": "Origen",
      "balanceAfter": "Saldo",
      "count": "Cantidad",
      "operationNumber": "Operación",
      "equipmentTag": "Equipo",
      "equipmentName": "Nombre del equipo",
      "plantName": "Planta",
      "taskCount": "Tareas",
      "plannedWoCount": "OT planificadas",
      "period": "Período"
    },
    "unit": {
      "days": "días",
      "hours": "horas",
      "cycles": "ciclos"
    },
    "status": {
      "draft": "Borrador",
      "open": "Abierta",
      "active": "Activo",
      "in_progress": "En progreso",
      "paused": "Pausada",
      "completed": "Completada",
      "closed": "Cerrada",
      "cancelled": "Cancelada",
      "canceled": "Cancelada",
      "deleted": "Eliminado",
      "pending": "Pendiente",
      "approved": "Aprobada",
      "partial": "Parcial",
      "rejected": "Rechazada",
      "auto_approved": "Aprobada automáticamente",
      "technically_complete": "Técnicamente completada"
    },
    "export": {
      "xlsx": "Exportar Excel",
      "pdf": "Exportar PDF (.docx)",
      "generating": "Generando archivo…",
      "error": "Error al exportar."
    }
  },
  "actions": {
    "approve": "Aprobar",
    "adjust": "Ajustar",
    "dismiss": "Descartar",
    "yes": "Sí",
    "no": "No"
  },
  "auth": {
    "signIn": "Iniciar sesión",
    "signUp": "Crear cuenta",
    "signOut": "Cerrar sesión",
    "statusUnavailable": "Verificación de acceso temporalmente no disponible. Reintentando.",
    "pendingApproval": {
      "title": "Esperando aprobación",
      "message": "Tu registro está esperando aprobación de un administrador. Se te redirigirá automáticamente cuando seas aprobado."
    }
  },
  "connection": {
    "signIn": "Iniciar sesión",
    "status": {
      "disconnected": "Desconectado",
      "connecting": "Conectando...",
      "connected": "Engine en línea",
      "reconnecting": "Reconectando... ({{count}}/{{max}})",
      "degraded": "Modo alternativo (REST)",
      "offline": "Sin conexión, mensajes en cola"
    },
    "banner": {
      "degraded": "Conexión inestable. Usando modo alternativo (REST).",
      "offline": "Sin conexión. Los mensajes se enviarán al reconectar.",
      "reconnecting": "Reconectando con el Engine..."
    }
  },
  "team": {
    "previousDeliveryPending": "Aún no se confirmó la revocación del correo anterior. Usa solo este nuevo enlace.",
    "invitationSent": "Invitación enviada a {{email}}. El enlace también está disponible abajo.",
    "pending": {
      "copy": "Copiar enlace",
      "copied": "Enlace copiado."
    },
    "invitationLink": "Enlace de aceptación",
    "shareInvitation": "Invitación creada. No se envió un correo. Comparte este enlace solo con {{email}}.",
    "invitationExpires": "Válido hasta {{date}}.",
    "title": "Equipo",
    "subtitle": "Gestiona miembros y roles del tenant",
    "member": "Miembro",
    "role": "Rol",
    "status": "Estado",
    "statusActive": "Activo",
    "statusSuspended": "Suspendido",
    "invite": "Invitar",
    "inviteTitle": "Invitar nuevo miembro",
    "email": "Correo",
    "selectRole": "Selecciona un rol",
    "sendInvite": "Crear invitación",
    "inviteSuccess": "Invitación generada con éxito",
    "inviteFailed": "Falla al generar invitación",
    "changeRole": "Cambiar rol",
    "revoke": "Quitar",
    "confirmRevoke": "¿Quitar a {{name}} del tenant?",
    "revokeSuccess": "Miembro quitado",
    "revokeFailed": "Falla al quitar",
    "roleChangedSuccess": "Rol actualizado",
    "roleChangeFailed": "Falla al actualizar rol",
    "changeRoleTitle": "Cambiar rol de {{name}}",
    "newRole": "Nuevo rol",
    "saveRole": "Guardar",
    "empty": "Aún no hay miembros en este tenant",
    "roles": {
      "owner": "Propietario",
      "admin": "Administrador",
      "engineer": "Ingeniero",
      "viewer": "Visualizador",
      "field_technician": "Técnico de campo"
    }
  },
  "roles": {
    "title": "Roles y permisos",
    "subtitle": "Configura roles personalizados para el tenant",
    "system": "Sistema",
    "create": "Crear rol",
    "createSuccess": "Rol creado",
    "createFailed": "Falla al crear rol",
    "delete": "Eliminar",
    "confirmDelete": "¿Eliminar el rol {{name}}?",
    "deleteSuccess": "Rol eliminado",
    "deleteFailed": "Falla al eliminar rol",
    "bindFailed": "Falla al actualizar permiso",
    "selectPrompt": "Selecciona un rol para editar permisos",
    "permissionsFor": "Permisos de {{name}}",
    "systemReadOnly": "Los roles del sistema no se pueden editar",
    "counts": "{{permissions}} permisos · {{members}} miembros",
    "empty": "Ningún rol registrado",
    "createTitle": "Crear rol",
    "nameLabel": "Nombre del rol",
    "descriptionLabel": "Descripción (opcional)",
    "nameRequired": "Ingresa un nombre para el rol",
    "nameDuplicate": "Ya existe un rol con ese nombre",
    "bindingsUnavailable": "No fue posible cargar los permisos actuales de este rol; la edición está bloqueada para evitar inconsistencias.",
    "bindingsCount": "Este rol tiene {{count}} permisos vinculados"
  },
  "permissions": {
    "matrix": "Matriz de permisos",
    "resource": "Recurso",
    "actions": {
      "create": "Crear",
      "read": "Leer",
      "update": "Actualizar",
      "delete": "Eliminar",
      "approve": "Aprobar",
      "manage": "Gestionar"
    },
    "resources": {
      "work_order": "Órdenes de trabajo",
      "maint_plan": "Planes de mantenimiento",
      "equipment": "Equipos",
      "user": "Usuarios",
      "role": "Roles",
      "team": "Equipo"
    }
  },
  "invitation": {
    "title": "Fuiste invitado a {{tenant}}",
    "body": "{{inviter}} te invitó al rol \"{{role}}\" como {{email}}. Acepta para entrar.",
    "accept": "Aceptar invitación",
    "errorTitle": "Invitación no disponible",
    "notFoundBody": "No encontramos esta invitación. Verifica el enlace o pide una nueva a la persona que te invitó.",
    "expiredBody": "Esta invitación expiró, ya fue usada o fue revocada.",
    "requestNew": "Pedir una nueva invitación",
    "requestNewMailtoSubject": "Necesito una nueva invitación para AxiomGO",
    "goToSignIn": "Ya tengo una cuenta",
    "createAccount": "Crear cuenta y aceptar",
    "alreadyHaveAccount": "¿Ya tienes cuenta?",
    "signIn": "Iniciar sesión",
    "mismatchTitle": "Esta invitación es para otra cuenta",
    "mismatchBody": "Esta invitación fue enviada a {{invited}}. Iniciaste sesión como {{current}}.",
    "switchAccount": "Iniciar sesión con otra cuenta",
    "acceptErrorUsed": "No se pudo aceptar esta invitación para esta cuenta. Contacta al administrador.",
    "mismatchGenericBody": "El correo de tu cuenta no coincide con el correo de la invitación.",
    "acceptErrorNetwork": "No se pudo completar ahora. Intenta de nuevo.",
    "retry": "Intentar de nuevo",
    "switchToInvited": "Salir e ingresar con {{email}}",
    "verifyEmailBody": "Verifica el correo invitado en tu cuenta antes de aceptar. Un correo no verificado no autoriza la aceptación.",
    "revokedBody": "Esta invitación fue revocada. Pide una nueva invitación al administrador.",
    "supersededBody": "Esta invitación fue reemplazada. Usa el enlace de la invitación más reciente.",
    "usedBody": "Esta invitación ya fue aceptada. Ingresa con la cuenta que la aceptó.",
    "alreadyMemberBody": "Esta cuenta ya es miembro de esta empresa. Abre el chat para continuar."
  },
  "signup": {
    "title": "Crear cuenta",
    "description": "Comienza gratis en segundos",
    "submit": "Crear cuenta",
    "email": "Correo",
    "name": "Nombre",
    "existing": "¿Ya tienes cuenta?",
    "signIn": "Iniciar sesión"
  },
  "onboarding": {
    "progress": {
      "phase": {
        "profile": "Su perfil",
        "equipment": "Base de datos",
        "plan": "Plan de mantenimiento",
        "team": "Equipo y materiales",
        "done": "Todo listo"
      },
      "eta_one": "≈ {{count}} min restante",
      "eta_other": "≈ {{count}} min restantes",
      "aria_one": "Progreso de la incorporación: fase {{index}} de {{total}}, {{phase}}. Cerca de {{count}} minuto restante.",
      "aria_other": "Progreso de la incorporación: fase {{index}} de {{total}}, {{phase}}. Cerca de {{count}} minutos restantes.",
      "ariaComplete": "Progreso de la incorporación: fase {{index}} de {{total}}, {{phase}}."
    },
    "plan": {
      "title": "Elige tu plan",
      "subtitle": "Empieza gratis o desbloquea funciones avanzadas para tu equipo.",
      "select": "Elegir {{plan}}"
    }
  },
  "billing": {
    "accessDenied": "Solo el propietario de la cuenta puede ver la suscripción y la facturación. Habla con él si necesitas algo aquí.",
    "title": "Suscripción",
    "subtitle": "Plan actual: {{plan}}",
    "currentPlan": "Plan actual",
    "loading": "Cargando…",
    "planNames": {
      "b2c_personal": "Acceso integral"
    },
    "unlimited": "Ilimitado",
    "manage": {
      "title": "Gestionar suscripción",
      "description": "Actualiza tarjeta, descarga facturas o cancela en el portal de Stripe.",
      "button": "Abrir portal"
    },
    "checkout": {
      "noUrl": "Stripe no devolvió URL, intenta de nuevo."
    },
    "status": {
      "active": "Activa",
      "past_due": "Pago atrasado",
      "canceled": "Cancelada",
      "trialing": "Período de prueba"
    },
    "quota": {
      "tokens": "Tokens / mes",
      "entities": "Entidades"
    }
  },
  "usage": {
    "title": "Uso actual",
    "tokens": "Tokens",
    "entities": "Entidades",
    "tokensQuota": "Tokens · contado en la cuota",
    "entitiesQuota": "Entidades · contado en la cuota",
    "equipment_zero": "{{n}} equipos",
    "equipment_one": "{{n}} equipo",
    "equipment_other": "{{n}} equipos",
    "workOrders_zero": "{{n}} órdenes de trabajo",
    "workOrders_one": "{{n}} orden de trabajo",
    "workOrders_other": "{{n}} órdenes de trabajo",
    "plans_zero": "{{n}} planes",
    "plans_one": "{{n}} plan",
    "plans_other": "{{n}} planes",
    "actualLine": "Consumo real en el período: {{tokens}} tokens"
  },
  "memory": {
    "updated": "Memoria actualizada",
    "toggle": {
      "on": "Memoria ON",
      "off": "Memoria OFF",
      "ariaOn": "Memoria activada en esta conversación, toca para desactivar",
      "ariaOff": "Memoria desactivada en esta conversación, toca para activar",
      "titleOn": "El curador está guardando aprendizajes de esta conversación",
      "titleOff": "Nada de esta conversación se está guardando en memoria"
    },
    "settings": {
      "title": "Memoria de la operación",
      "backToChat": "Volver al chat",
      "searchPlaceholder": "Buscar hechos…",
      "export": "Exportar (JSON)",
      "wipe": "Borrar todo",
      "wipeConfirm1": "¿Estás seguro?",
      "wipeConfirm2": "Confirmar borrar todo",
      "loading": "Cargando…",
      "totalCount": "{{count}} hechos en total",
      "listLabel": "Lista de hechos de la memoria",
      "edit": "Editar",
      "delete": "Borrar",
      "save": "Guardar",
      "cancel": "Cancelar",
      "empty": "Aún no hay hechos en la memoria, aparecen conforme conversas.",
      "confirmDelete": "¿Borrar este hecho?",
      "savedToast": "Hecho actualizado.",
      "deletedToast": "Hecho eliminado.",
      "wipedToast": "{{count}} hechos eliminados.",
      "exportedToast": "Exportación iniciada, revisa tus descargas."
    },
    "lgpd": {
      "description": "Estos hechos fueron extraídos de tus conversaciones por el curador. Puedes editar, borrar o exportar en cualquier momento (LGPD/LFPDPPP)."
    }
  },
  "trajectory": {
    "repetitions": "{{count}} actualizaciones agrupadas",
    "labels": {
      "pending": "Pendiente",
      "running": "En ejecución",
      "done": "Concluido",
      "error": "Error"
    },
    "steps": {
      "searching": "Buscando información",
      "sources": "Consultando fuentes",
      "analyzing": "Analizando datos",
      "tools": "Ejecutando acción",
      "generating": "Elaborando respuesta",
      "reasoning": "Razonando"
    },
    "expand": "Expandir",
    "collapse": "Contraer",
    "viewAll": "Ver {{count}} más",
    "expandCard": {
      "expand": "Expandir tarjeta",
      "expandedBadge": "Tarjeta abierta en pantalla completa",
      "title": {
        "web_search": "Sugerencia de plan, armada por Axis",
        "action_cards": "Acciones sugeridas",
        "proposal": "Propuesta",
        "form": "Formulario",
        "kpi": "Indicadores",
        "import": "Importación",
        "task_materials": "Materiales por tarea",
        "plan_edit": "Plan de mantenimiento: revisar",
        "resource_allocation": "Asignación de recursos",
        "equipment_search": "Resultado del equipo",
        "preventive_draft": "Plan preventivo: borrador"
      }
    }
  },
  "workOrder": {
    "operation": {
      "actualStart": "Inicio Real",
      "actualEnd": "Fin Real",
      "totalTime": "Tiempo Total",
      "deltaPlannedVsActual": "Δ Previsto vs Real",
      "inProgress": "En progreso"
    }
  },
  "artifacts": {
    "open": "Abrir en panel",
    "openInPanel": "Abrir en panel",
    "viewMaterials": "Ver materiales",
    "close": "Cerrar panel",
    "empty": "No hay información disponible.",
    "unrenderable": "No fue posible mostrar este contenido.",
    "title": {
      "plan": "Plan de mantenimiento",
      "materials": "Lista de materiales",
      "wo": "Orden de trabajo",
      "import": "Importación",
      "citation": "Fuente",
      "insights": "Indicadores",
      "schedule": "Cronograma"
    },
    "citation": {
      "openLink": "Abrir enlace original"
    },
    "materials": {
      "empty": "No hay materiales listados en este plan.",
      "code": "Código",
      "name": "Nombre",
      "qty": "Cant.",
      "unit": "Unidad"
    },
    "wo": {
      "status": "Estado",
      "priority": "Prioridad",
      "equipment": "Equipo",
      "location": "Ubicación",
      "team": "Equipo de trabajo",
      "plannedStart": "Inicio previsto",
      "plannedEnd": "Fin previsto",
      "plannedDuration": "Duración prevista",
      "operations": "Operaciones",
      "operationSequence": "Sec."
    },
    "insights": {
      "loadingChart": "Cargando gráfico...",
      "blockFailed": "No se pudo mostrar este bloque.",
      "gallery": {
        "title": "Galería de Axis Insights",
        "description": "Todos los bloques del panel de indicadores, en todos los estados, a partir de ejemplos fijos. Referencia de las pruebas visuales; no es una pantalla del producto.",
        "empty": "Todavía no hay bloques en la galería."
      },
      "panel": {
        "refresh": "Actualizar panel",
        "refreshPrompt": "Actualiza el panel \"{{title}}\" con los datos de ahora",
        "pin": "Fijar panel"
      },
      "quality": {
        "title": "Atención a la calidad del dato"
      },
      "kpi": {
        "noValue": "sin valor: muestra insuficiente",
        "vs": "vs {{period}}",
        "direction": {
          "up": "subió {{delta}}",
          "down": "bajó {{delta}}",
          "flat": "estable {{delta}}"
        }
      },
      "chart": {
        "retry": "Intentar de nuevo",
        "retryPrompt": "Dibuja de nuevo el gráfico \"{{title}}\"",
        "failed": "Este gráfico no pudo dibujarse.",
        "aria": "Gráfico: {{title}}. {{summary}}"
      },
      "table": {
        "sortAsc": "Ordenar ascendente por {{column}}",
        "sortDesc": "Ordenar descendente por {{column}}",
        "page": "Página {{page}} de {{total}}",
        "prev": "Página anterior",
        "next": "Página siguiente",
        "rows": "{{shown}} de {{total}} filas"
      },
      "tools": {
        "title": "Lo que la IA ejecutó",
        "params": "Parámetros",
        "result": "Resultado",
        "noParams": "Sin parámetros.",
        "summary": "Resultado: {{resumo}}",
        "state": {
          "preparing": "preparando",
          "running": "ejecutando",
          "done": "completado",
          "error": "falló"
        }
      },
      "chips": {
        "aria": "Sugerencias de pregunta",
        "indicators": "Preguntas listas",
        "indicatorsHint": "Preguntas listas sobre indicadores y auditoría de datos"
      },
      "report": {
        "severity": {
          "high": "alta",
          "medium": "media",
          "info": "informativo"
        },
        "detections": "Detecciones",
        "method": "Método: {{name}} · n={{n}}",
        "trendNotDate": "es tendencia, no pronóstico de fecha"
      }
    }
  },
  "citations": {
    "tooltip": {
      "viewSource": "Abrir en panel"
    },
    "unavailable": "Fuente no disponible",
    "loading": "Cargando fuente…",
    "error": "No se pudo cargar la fuente.",
    "retry": "Intentar de nuevo",
    "typeLabel": {
      "doc": "Documento",
      "wo": "Orden de trabajo",
      "norma": "Norma técnica",
      "equip": "Equipo"
    },
    "wo": {
      "unavailable": "Orden de trabajo no disponible en este momento.",
      "notFound": "Orden de trabajo no encontrada."
    }
  },
  "validator": {
    "fallback": {
      "phantomTag": "No fue posible confirmar con seguridad los equipos referenciados en esta respuesta. Por favor, refine la consulta, por ejemplo, indique un tag específico, una planta o una ubicación, e inténtelo de nuevo.",
      "enforceExhausted": "No pude generar una respuesta confiable para esta solicitud en este momento. Intente reformularla o contacte al soporte."
    }
  },
  "voice": {
    "errors": {
      "notSupported": "El comando de voz no es compatible con este navegador.",
      "notAllowed": "Permiso de micrófono denegado.",
      "noSpeech": "No escuché nada. Inténtalo de nuevo.",
      "audioCapture": "No se pudo acceder al micrófono.",
      "aborted": "Captura de voz interrumpida.",
      "network": "Error de red en el reconocimiento de voz.",
      "serviceNotAllowed": "Servicio de voz no disponible.",
      "languageNotSupported": "Idioma no compatible para voz.",
      "synthesisFailed": "No se pudo narrar la respuesta.",
      "unknown": "Error de voz desconocido."
    },
    "provenance": {
      "suppressedUnbackedIdentifiers": "Se omitieron algunos identificadores no verificados de la narración."
    },
    "listening": "Detener y enviar",
    "pushToTalk": "Decir un comando",
    "stopNarration": "Detener narración",
    "permissionLost": "Permiso de micrófono perdido",
    "disambiguateOp": "¿Cuál operación? {{options}}",
    "enable": "Activar voz",
    "disable": "Desactivar voz",
    "narrationTruncated": "Narración abreviada. Consulta la respuesta completa en pantalla.",
    "disabledMeeting": "Micrófono no disponible durante la grabación de la reunión"
  },
  "equipmentRegistration": {
    "commit": {
      "saving": "Guardando…",
      "offline": "Sin conexión con el servidor. Todavía no se guardó nada.",
      "tagTaken": "La etiqueta {{tag}} ya existe en esta planta. Elige otra.",
      "stale": "Los datos cambiaron, revisa este paso.",
      "forbidden": "Tu perfil no tiene permiso para registrar equipos.",
      "planLimit": "Alcanzaste el límite de equipos de tu plan.",
      "refusedTitle": "Registro no guardado",
      "savedTitle": "Registro guardado",
      "wait": "El servidor pidió una pausa. Intenta de nuevo en {{segundos}} s.",
      "waitShort": "Demasiados intentos seguidos. Espera un momento e intenta de nuevo.",
      "syncFailed": "No pude guardar el avance del registro antes de tu mensaje. Sigue en el campo; intenta enviarlo de nuevo."
    },
    "identity": {
      "title": "¿Cuál es la marca, el modelo y la descripción del equipo?",
      "hint": "Sugerimos una etiqueta a partir de la marca y el modelo, puedes aceptarla o escribir la tuya en el siguiente paso.",
      "manufacturerPlaceholder": "Marca (ej.: Krones)",
      "modelPlaceholder": "Modelo (ej.: Modulfill VFS)",
      "descriptionPlaceholder": "Descripción completa (ej.: compresor de tornillo de la sala de utilidades)",
      "titleSeeded": "Confirma la marca y el modelo del equipo.",
      "hintSeeded": "Trajimos la marca y el modelo que ya indicaste. Revisa, ajusta si hace falta y confirma; la etiqueta viene en el siguiente paso.",
      "submitSeeded": "Confirmar"
    },
    "intro": {
      "title": "¿Registramos este equipo?",
      "body": "Para registrar {{manufacturer}} {{model}} necesito una Planta y una Ubicación.",
      "requirements": "Necesitaré la planta y la ubicación donde está instalado.",
      "continue": "Continuar"
    },
    "plant": {
      "title": "¿En qué planta está este equipo?",
      "loading": "Cargando plantas...",
      "error": "Error al cargar plantas.",
      "newPlant": "Crear nueva planta",
      "newPlantHint": "Proporcione el nombre de la nueva planta. El código puede generarse automáticamente.",
      "autoCodeLabel": "Generar código automáticamente",
      "codePlaceholder": "Código (ej.: PLT-01)",
      "namePlaceholder": "Nombre de la planta",
      "countryPlaceholder": "País (opcional)",
      "currencyPlaceholder": "Moneda",
      "createPlant": "Crear planta",
      "errorForbidden": "Sin permiso para ver las plantas. Cree una nueva abajo."
    },
    "location": {
      "title": "¿Y en qué ubicación, dentro de la planta?",
      "loading": "Cargando ubicaciones...",
      "error": "Error al cargar ubicaciones.",
      "noLocations": "Esta planta aún no tiene ubicaciones. Cree la primera a continuación.",
      "newLocation": "Crear nueva ubicación",
      "autoCodeLabel": "Generar código automáticamente",
      "codePlaceholder": "Código (ej.: LOC-A)",
      "descriptionPlaceholder": "Descripción (opcional)",
      "createLocation": "Crear ubicación"
    },
    "tag": {
      "title": "¿Cómo quieres identificarlo (la etiqueta)?",
      "hint": "La etiqueta identifica el equipo de forma única en su planta.",
      "autoPreview": "Etiqueta sugerida: {{tag}}",
      "generateAuto": "Generar automáticamente",
      "haveTag": "Ya tengo una etiqueta",
      "placeholder": "ej.: KRN-001",
      "submit": "Usar esta etiqueta",
      "sequenceOnConfirm": "(se genera al confirmar)"
    },
    "criticality": {
      "title": "¿Qué criticidad tiene: A, B o C?",
      "hint": "Define la prioridad de mantenimiento. Predeterminado: C (Normal).",
      "optionA": "Crítico",
      "descA": "Si se detiene, la producción se detiene",
      "optionB": "Importante",
      "descB": "Si se detiene, afecta parte de la producción",
      "optionC": "Normal",
      "descC": "Sin impacto inmediato en la producción",
      "confirm": "Confirmar criticidad"
    },
    "confirming": {
      "title": "¿Está todo correcto para registrar?",
      "equipment": "Equipo: {{manufacturer}} {{model}}",
      "tag": "Etiqueta: {{tag}}",
      "criticality": "Criticidad: {{criticality}}",
      "plant": "Planta (existente): {{name}}",
      "plantFallback": "planta ya seleccionada",
      "newPlant": "Nueva planta: {{code}} ({{name}})",
      "location": "Ubicación (existente): {{name}}",
      "locationFallback": "ubicación ya seleccionada",
      "newLocation": "Nueva ubicación: {{code}}",
      "confirm": "Confirmar registro"
    },
    "summary": {
      "start": "Registrar equipo: {{value}}.",
      "startBare": "Registrar equipo.",
      "equipment": "Equipo: {{value}}.",
      "plant": "Planta: {{value}}.",
      "plantBare": "Planta seleccionada.",
      "newPlant": "Nueva planta: {{value}}.",
      "location": "Ubicación: {{value}}.",
      "locationBare": "Ubicación seleccionada.",
      "newLocation": "Nueva ubicación: {{value}}.",
      "tagAuto": "Etiqueta generada automáticamente.",
      "tagManual": "Etiqueta manual: {{value}}.",
      "criticality": "Criticidad: {{value}}.",
      "confirm": "Confirmar registro del equipo.",
      "cancel": "Cancelar registro del equipo.",
      "back": "Volver al paso anterior.",
      "generic": "Acción de registro de equipo."
    },
    "done": {
      "title": "Equipo registrado exitosamente.",
      "railBody": "Planta, ubicación y equipo registrados.",
      "railBodyLocationEquipment": "Ubicación nueva registrada en la planta que ya existía.",
      "railBodyEquipmentOnly": "En la planta y la ubicación que ya existían.",
      "railQuestion": "Usted decide el próximo paso. ¿Quiere armar el plan preventivo del equipo o abrir una orden de trabajo correctiva para una falla actual?",
      "actions": {
        "plan": {
          "label": "Crear plan preventivo",
          "message": "Quero montar um plano de manutenção preventiva para o equipamento {{tag}}"
        },
        "corrective": {
          "label": "Abrir orden correctiva",
          "message": "Abrir orden correctiva para el equipo {{tag}}"
        },
        "view": {
          "label": "Ver el equipo",
          "message": "Mostrar o equipamento {{tag}}"
        }
      }
    },
    "cancelled": {
      "title": "Registro cancelado",
      "body": "No se guardó ningún dato. Puedes empezar de nuevo cuando quieras."
    },
    "common": {
      "back": "Volver",
      "cancel": "Cancelar registro",
      "retry": "Intentar de nuevo"
    }
  },
  "equipmentSearch": {
    "form": {
      "equipmentType": "Tipo de equipo",
      "equipmentTypePlaceholder": "Ej.: Compresor",
      "manufacturer": "Fabricante",
      "manufacturerPlaceholder": "Ej.: Atlas Copco",
      "model": "Modelo",
      "modelPlaceholder": "Ej.: GA37",
      "submit": "Buscar plan del fabricante"
    },
    "card": {
      "title": "Mis equipos",
      "count": "{{count}} equipos",
      "count_one": "{{count}} equipo",
      "count_other": "{{count}} equipos",
      "empty": "No se encontraron equipos.",
      "hasMore": "Mostrando {{returned}} de {{total}}.",
      "listMoreAria": "{{label}} (página {{page}})",
      "viewHistory": "Ver historial",
      "searchManufacturer": "Buscar datos en la WEB",
      "viewHistoryQuery": "Histórico do equipamento {{tag}}",
      "searchManufacturerQuery": "Me fale do {{equipment}}",
      "createWorkOrder": "Crear orden de trabajo",
      "details": "Detalles del equipo"
    },
    "criticality": {
      "A": "A · Crítico",
      "B": "B · Importante",
      "C": "C · Normal"
    },
    "optionalSuffix": " (opcional)"
  },
  "planDetail": {
    "active": "Activo",
    "inactive": "Inactivo",
    "strategy": "Estrategia",
    "interval": "Intervalo",
    "nextDue": "Próxima ejecución",
    "counts": "Tareas / materiales",
    "tasksHeading": "Tareas",
    "tasksEmpty": "Plan sin tareas.",
    "materialsHeading": "Materiales"
  },
  "notificationDetailing": {
    "resources": {
      "team": "Equipo",
      "specialty": "Especialidad (del equipo)",
      "technician": "Técnico",
      "select": "Seleccione",
      "loadError": "No se pudieron cargar equipos o técnicos. Intente de nuevo."
    },
    "missingLabel": "Falta completar:",
    "plannedStart": "Fecha planificada",
    "plannedStartTime": "Hora (opcional)",
    "timeWillBeAssumed": "Sin hora: el sistema asume el inicio de la jornada y muestra la hora para que la confirme.",
    "timeAssumed": "Hora asumida: inicio de la jornada ({{time}}). Confírmela o cámbiela antes de guardar.",
    "errors": {
      "sendFailed": "No se pudo enviar. Revise la conexión e intente de nuevo.",
      "descriptionRequired": "Ingrese la descripción de la operación; solo espacios no son válidos.",
      "pastDate": "Elige una fecha futura.",
      "invalidDate": "Fecha inválida."
    },
    "operationTitle": "Operación {{sequence}}",
    "operationsField": "Operaciones",
    "missingInOperation": "{{field}} (operación {{sequence}})",
    "description": "Descripción",
    "duration": "Tiempo planificado",
    "durationUnit": "Unidad",
    "unit": {
      "MINUTES": "Minutos",
      "HOURS": "Horas",
      "DAYS": "Días"
    },
    "technicians": "N.º de técnicos",
    "condition": "Condición de instalación",
    "conditionPlaceholder": "No informada",
    "systemCondition": {
      "OPERATING": "Máquina funcionando",
      "PARTIAL_STOP": "Parada parcial",
      "FULL_STOP": "Parada total"
    },
    "newOperation": "Nueva operación",
    "addOperation": "Agregar operación",
    "save": "Guardar y salir",
    "stop": "Detener la OT"
  },
  "operationsPanel": {
    "materials": {
      "planned": "Materiales planificados",
      "unlinked": "Sin operación vinculada",
      "unavailable": "Operación vinculada no disponible"
    },
    "defaultInspection": "Inspeccionar y diagnosticar la falla reportada en el equipo",
    "plannedTime": "Tiempo planificado: {{time}}",
    "plannedStart": "Inicio planificado: {{date}}",
    "technicianLabel": "Técnico: {{name}}",
    "plannedDuration": {
      "hours": "{{hours}} h",
      "minutes": "{{minutes}} min",
      "hoursMinutes": "{{hours}} h {{minutes}} min"
    },
    "systemConditionLabel": "Condición del sistema: {{condition}}",
    "systemCondition": {
      "OPERATING": "Máquina en marcha",
      "PARTIAL_STOP": "Parada parcial",
      "FULL_STOP": "Parada total"
    },
    "actions": {
      "assignTechnician": "Asignar técnico",
      "addMaterial": "Agregar material",
      "addOperation": "Agregar más operaciones",
      "closeOrder": "Cerrar orden",
      "reviewClosure": "Revisar cierre de la orden",
      "confirmMaterialConsumption": "Confirmar consumo de material",
      "start": "Iniciar",
      "pause": "Pausar",
      "resume": "Reanudar",
      "finishOperation": "Finalizar operación"
    },
    "missingLabel": "Falta: {{items}}",
    "missing": { "technician": "técnico", "material_optional": "material (opcional)" },
    "closeOperation": {
      "title": "Operación {{operation}}: ¿qué se hizo?",
      "cause": "Causa (ISO 14224)",
      "selectCause": "Seleccione la causa",
      "executedBy": "Quién ejecutó (opcional)",
      "executedByRequired": "Quién ejecutó (obligatorio)",
      "team": "Equipo: {{name}}",
      "activeTime": "Tiempo activo {{time}} · calculado, sin escribir",
      "openingTime": "Tiempo al abrir el cierre {{time}}",
      "note": "Qué se hizo",
      "noteMinimum": "{{count}}/{{minimum}} caracteres (mínimo)",
      "noteCount": "{{count}} caracteres",
      "back": "Volver",
      "submit": "Cerrar operación {{operation}}"
    },
    "pending": { "title": "La operación sigue abierta.", "description": "¿Qué quieres hacer?" },
    "reservedMaterial": {
      "title": "Revisar materiales reservados",
      "description": "Revisa los materiales reservados y las cantidades seleccionadas."
    },
    "closeOrder": {
      "title": "Revisión de la orden",
      "note": "Qué se hizo",
      "description": "Revisa la orden y sus operaciones antes de continuar."
    },
    "closed": { "title": "Orden cerrada" }
  },
  "workOrderDetail": {
    "planning": {
      "duration": "Duración de la operación",
      "plannedMinutes": "Tiempo previsto",
      "team": "Equipo planificado",
      "specialty": "Especialidad",
      "technician": "Técnico planificado",
      "performedBy": "Ejecución registrada",
      "unitUnknown": "{{value}} (unidad no informada)",
      "units": {
        "HOURS": "{{value}} h",
        "MINUTES": "{{value}} min",
        "DAYS": "{{value}} días"
      }
    },
    "organization": {
      "condition": "Condición",
      "plant": "Planta",
      "team": "Equipo",
      "noTeam": "Sin equipo",
      "unknown": "No informada"
    },
    "completionActions": {
      "open": {
        "label": "Nueva orden correctiva",
        "message": "Abrir orden correctiva para el equipo {{tag}}"
      },
      "view": {
        "label": "Ver equipos",
        "message": "Mostrar el equipo {{tag}}"
      },
      "plan": {
        "label": "Generar plan preventivo",
        "message": "Quiero crear un plan de mantenimiento preventivo para el equipo {{tag}}"
      }
    },
    "priority": "Prioridad",
    "type": "Tipo",
    "scheduledStart": "Inicio programado",
    "scheduledEnd": "Fin programado",
    "numberColumn": "OT",
    "updatedAt": "Actualizado el",
    "descriptionHeading": "Descripción",
    "notificationHeading": "Notificación vinculada",
    "operationsHeading": "Operaciones",
    "operationsEmpty": "Orden de trabajo sin operaciones.",
    "componentsHeading": "Componentes",
    "status": {
      "draft": "Borrador",
      "planned": "Planificada",
      "in_progress": "En progreso",
      "released": "Liberada",
      "technically_complete": "Cierre técnico",
      "completed": "Completada",
      "canceled": "Cancelada",
      "desconhecido": "Estado desconocido"
    },
    "opStatus": {
      "pending": "Pendiente",
      "in_progress": "En progreso",
      "completed": "Completada",
      "paused": "Pausada",
      "cancelled": "Cancelada",
      "desconhecido": "Estado desconocido"
    },
    "preventiveNormalPriority": "Normal",
    "priorityLevel": {
      "critical": "Emergencia",
      "high": "Urgente",
      "medium": "Importante",
      "low": "Baja",
      "desconhecido": "Prioridad desconocida"
    },
    "unit": {
      "pc_one": "ud.",
      "pc_other": "uds.",
      "lt": "L",
      "kg": "kg",
      "m": "m"
    },
    "woType": {
      "corrective": "Correctiva",
      "preventive": "Preventiva",
      "predictive": "Predictiva",
      "improvement": "Mejora",
      "desconhecido": "Tipo desconocido"
    }
  },
  "planEdit": {
    "frequencyUnrecognized": "Frecuencia no reconocida, defínala",
    "frequencyConditionBased": "Tarea por condición: la fuente no da un intervalo fijo. Defina cada cuánto revisarla.",
    "sourceFrequency": "Frecuencia en el plan original",
    "title": "Plan de mantenimiento: revisar",
    "col": {
      "index": "N.º",
      "tarefa": "Tarea",
      "inicioCiclo": "Inicio de ciclo",
      "frequencyUnit": "Unidad de frecuencia",
      "origem": "Origen"
    },
    "confirm": "Confirmar plan",
    "cancel": "Volver",
    "error": {
      "descriptiveFrequencyInvalid": "No se pudo validar la frecuencia descriptiva recibida.",
      "dateInvalid": "Fecha inválida, use dd/mm/aaaa",
      "unitRequired": "Elige la unidad de la frecuencia",
      "required": "Obligatorio"
    },
    "freqUnit": {
      "HOURS": "horas",
      "DAYS": "días",
      "WEEKS": "semanas",
      "MONTHS": "meses",
      "YEARS": "años",
      "CYCLES": "ciclos"
    },
    "replicateDate": "Replicar esta fecha en las demás tareas",
    "replicate": "Replicar",
    "taskPlaceholder": "Describe la tarea",
    "duplicateBadge": "Tarea repetida",
    "dataNoPassado": "Inicio en el pasado",
    "requiredField": "obligatorio",
    "requiredCount": "{{count}} fila(s) con campos obligatorios en blanco",
    "requiredJump": "Ir a la primera",
    "bulkDate": {
      "label": "Inicio de ciclo para todas las filas",
      "apply": "Aplicar a las vacías"
    },
    "empty": {
      "linha": "Todavía no hay tareas. Agréguelas abajo, o vuelva y pida la búsqueda del plan.",
      "confirmBloqueado": "No hay tarea para confirmar"
    },
    "source": {
      "page": "pág. {{page}}",
      "pageAria": "Página {{page}} del manual",
      "quoteSummary": "Fragmento del manual"
    },
    "provenance": {
      "fabricante": {
        "rotulo": "Fabricante",
        "ajuda": "Extraído del manual del fabricante por Axis. Verifique en el documento original."
      },
      "cliente": {
        "rotulo": "Su plan",
        "ajuda": "Tarea del plan que usted ya usa, como está en su planilla."
      },
      "analogia": {
        "rotulo": "Analogía",
        "ajuda": "Viene del documento del fabricante de otro modelo de la misma arquitectura. Revise antes de aplicar."
      },
      "pratica_setor": {
        "rotulo": "Práctica del sector",
        "ajuda": "Práctica consolidada para esta clase de equipo, y no documento del fabricante. Revise antes de aplicar."
      },
      "inferencia": {
        "rotulo": "Inferido por la máquina",
        "ajuda": "Deducido a partir de la arquitectura de la máquina, y no documento del fabricante. Revise antes de aplicar."
      },
      "norma": {
        "rotulo": "Norma técnica",
        "ajuda": "Exigida por norma técnica (NR, ISO) para este tipo de equipo, y no por el documento del fabricante. Verifique la norma citada antes de aplicar."
      }
    }
  },
  "teamRoster": {
    "title": "Registro de Equipo",
    "col": {
      "name": "Nombre",
      "role": "Rol",
      "email": "Correo",
      "personnelNumber": "N.° de personal",
      "specialties": "Especialidades"
    },
    "role": {
      "placeholder": "Seleccionar",
      "mechanic": "Mecánico",
      "electrician": "Electricista",
      "instrumentist": "Instrumentista",
      "electromechanic": "Electromecánico",
      "lubricator": "Lubricador",
      "welder": "Soldador",
      "boilermaker": "Calderero",
      "refrigeration_technician": "Técnico de Refrigeración y Climatización",
      "automation_technician": "Técnico de Automatización",
      "predictive_analyst": "Analista de Predictivo (Vibración y Termografía)",
      "civil_maintainer": "Mantenedor Civil",
      "hydraulics_pneumatics_technician": "Técnico de Hidráulica y Neumática",
      "operator": "Operador",
      "planner": "Planificador (PCM)",
      "supervisor": "Supervisor",
      "helper": "Auxiliar de Mantenimiento"
    },
    "specialtiesPlaceholder": "Separadas por coma",
    "addRow": "Agregar técnico",
    "removeRow": "Quitar fila",
    "confirm": "Concluir equipo",
    "error": {
      "roleRequired": "Elija el rol del técnico"
    }
  },
  "materialsInventory": {
    "title": "Inventario de Materiales",
    "col": {
      "code": "Código del Material",
      "description": "Descripción del Material",
      "quantity": "Ingresar Inventario",
      "unit": "Unidad"
    },
    "addRow": "Agregar material",
    "removeRow": "Quitar fila",
    "confirm": "Concluir materiales"
  },
  "alerts": {
    "correctiveEmergency": {
      "title": "Mantenimiento correctivo de emergencia en {{equipment}}",
      "titleWithoutEquipment": "Mantenimiento correctivo de emergencia registrado",
      "body": "Se abrió un mantenimiento correctivo de emergencia para el equipo {{equipment}}.",
      "bodyWithoutEquipment": "Se abrió un mantenimiento correctivo de emergencia.",
      "report": "Reporte: {{description}}",
      "note": "Aviso {{number}}.",
      "action": "El equipo debe evaluar la parada ahora."
    },
    "bell": {
      "aria": "Avisos",
      "ariaWithCount_one": "Avisos, {{count}} sin leer",
      "ariaWithCount_other": "Avisos, {{count}} sin leer",
      "title": "Avisos"
    },
    "panel": {
      "aria": "Panel de avisos",
      "title": "Avisos"
    },
    "markRead": "marcar como leído",
    "markAllRead": "marcar todas como leídas",
    "beyondPage_one": "+{{count}} sin leer fuera de esta lista",
    "beyondPage_other": "+{{count}} sin leer fuera de esta lista",
    "empty": "No hay avisos.",
    "loading": "Cargando avisos...",
    "retry": "Reintentar",
    "error": {
      "load": "No pude cargar tus avisos."
    }
  },
  "osNotification": {
    "alertBody": "Toca para ver en AxiomGO.",
    "planReadyTitle": "Plan de mantenimiento listo",
    "planReadyBody": "El plan de {{label}} está listo para revisión."
  },
  "nps": {
    "pulse": {
      "title": "¿Cómo fue crear tu primer plan?",
      "subtitle": "De 0 a 10, ¿qué tanto recomendarías AxiomGO a otro profesional de mantenimiento?",
      "scoreGroupLabel": "Puntaje de 0 a 10",
      "scoreLabel": "Puntaje {{score}}",
      "anchorLow": "No lo recomendaría",
      "anchorHigh": "Lo recomendaría mucho",
      "commentLabel": "Comentario opcional",
      "commentPlaceholder": "¿Quieres contarnos por qué? (opcional)",
      "sending": "Enviando tu respuesta...",
      "error": "No pudimos registrar tu respuesta. Intenta enviarla otra vez.",
      "submit": "Enviar respuesta"
    }
  },
  "taskMaterials": {
    "stockSuggestionNotice": "El saldo sugerido usa la demanda agrupada del plan por código y unidad. No es inventario físico confirmado. Revise o borre el valor; no se guarda nada antes de confirmar.",
    "stockSuggested": "Demanda del plan · sugerencia",
    "stockDeclared": "Valor informado",
    "stockBlocked": "Sin sugerencia: este código aparece en varios lugares con cantidad ausente o inválida, unidad distinta o desconocida, o repetido en la misma tarea. Corríjalo o informe el saldo.",
    "col": {
      "code": "Código",
      "description": "Descripción",
      "quantity": "Cant.",
      "unit": "Unidad",
      "saldoInicial": "Saldo inicial"
    },
    "semMaterial": "Ningún material en esta tarea.",
    "addRow": "+ incluir material en esta tarea",
    "deleteRow": "Eliminar",
    "regiao": "Materiales por tarea",
    "invalidUnit": "Elige una unidad admitida: {{units}}."
  },
  "materialPicker": {
    "title": "¿Qué materiales usará la operación {{operation}}?",
    "search": "Buscar código, descripción, fabricante o pieza",
    "searchServer": "Buscar en el servidor",
    "shown": "{{shown}} de {{total}} mostrados",
    "stock": "En stock: {{count}} {{unit}}",
    "noStock": "Sin stock disponible",
    "quantity": "Cantidad a reservar",
    "selected": "{{count}} materiales seleccionados",
    "add": "Agregar {{count}} materiales",
    "selected_one": "{{count}} material seleccionado",
    "selected_other": "{{count}} materiales seleccionados",
    "add_one": "Agregar {{count}} material",
    "add_other": "Agregar {{count}} materiales",
    "expand": "Abrir detalles",
    "collapse": "Contraer detalles",
    "expandAll": "Abrir todos",
    "collapseAll": "Contraer todos",
    "balance": "Saldo",
    "reserved": "Reservado",
    "available": "Disponible",
    "empty": "No hay materiales registrados en el inventario.",
    "noResults": "No se encontraron resultados para esta búsqueda.",
    "register": "Registrar más materiales",
    "registerMessage": "Quiero registrar más materiales."
  },
  "importFlow": {
    "title": "Importación de planilla",
    "refusal": "Falta resolver: {{field}}",
    "choosingPath": {
      "body": "Dos caminos: enviar tu propia planilla, o descargar las plantillas para completar y volver después."
    },
    "awaitingFile": {
      "body": "Envía la planilla como adjunto. Acepto .xlsx, .xls y .csv de hasta 50 MB."
    },
    "analyzing": {
      "body": "Estoy leyendo tu planilla..."
    },
    "reviewing": {
      "body": "Revisa lo que entendí de cada hoja y resuelve los pendientes antes de confirmar."
    },
    "importing": {
      "body": "Importando los datos...",
      "retrying": "Tuve un tropiezo y estoy reintentando..."
    },
    "completed": {
      "body": "Importación completa: {{imported}} elementos ingresaron."
    },
    "completedWithPending": {
      "body": "Importación completa con pendientes: {{imported}} ingresaron y {{failed}} filas quedaron fuera."
    },
    "failed": {
      "body": "No pude importar nada: {{reason}}. No se guardó nada."
    },
    "canceled": {
      "body": "Importación cancelada. No se guardó nada.",
      "templates": "Plantillas listas. Complétalas y vuelve para enviar."
    },
    "expired": {
      "body": "Esta importación quedó detenida demasiado tiempo y expiró. Envía la planilla de nuevo."
    },
    "sheet": {
      "suggested": "parece {{entity}},",
      "unrecognized": "no reconocida,",
      "pending": "esperando tu decisión",
      "accepted": "va a entrar",
      "ignored": "fuera de la importación",
      "expired": "decisión expirada"
    },
    "actions": {
      "chooseImport": "Enviar planilla",
      "chooseTemplates": "Descargar plantillas",
      "resolvePending": "Registrar lo que falta",
      "replaceFile": "Cambiar planilla",
      "cancel": "Cancelar"
    }
  },
  "resourceAllocation": {
    "suggestion": {
      "specialty_match": "sugerencia: competencia declarada",
      "role_match": "sugerencia: por el rol en el equipo",
      "general_fallback": "sugerencia: atiende general",
      "no_match": "sin técnico con esta especialidad",
      "user_edit": "tu elección"
    },
    "suggestionAria": "Origen de la asignación"
  },
  "teamPicker": {
    "title": "¿Qué equipo atiende esta orden?",
    "emptyNoCreate": "No hay equipo registrado y no tiene permiso para registrar. Pida a un administrador.",
    "areaFilter": "Filtrar por área",
    "allAreas": "Todas",
    "openOrders_zero": "{{count}} órdenes abiertas",
    "openOrders_one": "{{count}} orden abierta",
    "openOrders_other": "{{count}} órdenes abiertas",
    "empty": "Aún no hay equipo registrado para esta planta.",
    "register": "Registrar equipo",
    "confirm": "Confirmar equipo",
    "form": {
      "name": "Nombre del equipo",
      "area": "Área",
      "nameHint": "Ej.: Mecánica Turno A",
      "areaHint": "Ej.: Hidráulica",
      "areaPlaceholder": "Elija el área",
      "cancel": "Cancelar",
      "submit": "Registrar y elegir"
    }
  },
  "technicianPicker": {
    "title": "¿Quién realizará la operación {{operation}}?",
    "teamFilter": "Filtrar por equipo",
    "allTeams": "Todos",
    "search": "Buscar técnicos",
    "openOrders_one": "{{count}} orden abierta",
    "openOrders_other": "{{count}} órdenes abiertas",
    "selected_one": "{{count}} técnico seleccionado",
    "selected_other": "{{count}} técnicos seleccionados",
    "register": "Registrar nuevo técnico",
    "form": {
      "name": "Nombre",
      "role": "Rol",
      "team": "Equipo",
      "noTeam": "Sin equipo",
      "email": "Correo (opcional)",
      "personnelNumber": "N.° de personal (opcional)",
      "cancel": "Cancelar",
      "submit": "Registrar y seleccionar"
    },
    "assign_one": "Asignar {{count}} técnico",
    "assign_other": "Asignar {{count}} técnicos"
  },
  "confirmDialog": {
    "title": "Confirmar acción",
    "confirm": "Confirmar"
  },
  "auris": {
    "menu": {
      "gravarReuniao": "Grabar reunión"
    },
    "modal": {
      "titulo": "Grabar reunión",
      "aviso": "El micrófono del equipo va a captar la conversación de la sala. El audio no se guarda: solo queda la transcripción, y es ella la que se convierte en el acta.",
      "participantes": "¿Cuántas personas hay en la sala?",
      "aceite": "Avisé a las personas de la sala que la conversación va a ser grabada.",
      "gravar": "Empezar a grabar",
      "assunto": "Asunto (opcional)"
    },
    "barra": {
      "gravando": "Grabando la reunión. El audio no se guarda.",
      "encerrando": "Cerrando y generando el acta...",
      "blocos": "{{count}} fragmentos enviados",
      "furada": "Un fragmento no subió. La grabación va a quedar incompleta.",
      "interrompida": "La grabación se detuvo en el servidor. Lo que ya se dijo está guardado; el resto no.",
      "continuar": "Continuar en una grabación nueva",
      "encerrar": "Terminar"
    },
    "card": {
      "titulo": "Acta de la reunión",
      "parcial": "La grabación se interrumpió antes del final. Parte de la conversación no quedó registrada.",
      "parcialAosMinutos": "Acta parcial: grabación interrumpida a los {{minutos}} minutos. Parte de la conversación no quedó registrada.",
      "parcialAoMinuto": "Acta parcial: grabación interrumpida a 1 minuto. Parte de la conversación no quedó registrada.",
      "parcialMenosDeUmMinuto": "Acta parcial: grabación interrumpida antes de 1 minuto. Parte de la conversación no quedó registrada.",
      "confiancaBaixa": "Algunos fragmentos quedaron con audio malo y pueden tener errores de transcripción.",
      "listaVazia": "Nada en esta lista.",
      "aprovarAta": "Aprobar acta",
      "aprovarItem": "Aprobar ítem",
      "efetivarItem": "Convertir en orden",
      "dono": "Responsable: {{nome}}",
      "donoPorApelido": "Responsable: {{nome}} (resuelto por apodo)",
      "lista": {
        "decisoes": "Decisiones",
        "tarefas": "Tareas",
        "pendencias": "Pendientes",
        "propostas": "Propuestas"
      },
      "ataNaoSaiu": "La reunión se guardó, pero el acta no pudo generarse ahora. La transcripción está guardada y se puede procesar de nuevo."
    },
    "impedimento": {
      "item_needs_attestation": "Falta atestiguar de memoria el fragmento que sostiene este ítem.",
      "item_has_no_evidence": "Este ítem no tiene fragmento de la conversación que lo sostenga.",
      "item_evidence_stale": "El fragmento que sostiene este ítem cambió después de la revisión.",
      "non_objection_needs_confirmation": "Falta confirmar que nadie se opuso.",
      "item_not_in_review": "Este ítem no está en revisión."
    },
    "recusa": {
      "transcription_provider_unconfigured": "La transcripción no está configurada en esta cuenta. La reunión no puede grabarse ahora, avise al responsable.",
      "transcription_provider_unavailable": "El servicio de transcripción no respondió. Intente de nuevo en unos minutos.",
      "consent_not_recorded": "No fue posible registrar el consentimiento. Sin él, el micrófono no se abre.",
      "notice_attestation_missing": "Diga cuántas personas hay en la sala antes de grabar.",
      "notice_text_unresolved": "El aviso de grabación de esta cuenta está incompleto. Avise al responsable.",
      "retention_policy_missing": "Esta cuenta no tiene plazo de guarda definido. La reunión no puede empezar.",
      "meeting_wrong_state": "Esta reunión ya fue cerrada.",
      "chunk_out_of_session": "La grabación se interrumpió en el servidor. Lo que ya se habló está guardado, el resto no.",
      "meeting_duration_exceeded": "La reunión pasó del tiempo máximo y fue cerrada.",
      "transcription_session_closed": "La sesión de transcripción ya estaba cerrada.",
      "item_not_in_review": "Este ítem no está en revisión.",
      "item_already_effectuated": "Este ítem ya fue convertido en orden.",
      "item_needs_attestation": "Falta atestiguar de memoria el fragmento de este ítem.",
      "item_has_no_evidence": "Este ítem no tiene fragmento que lo sostenga.",
      "item_evidence_stale": "El fragmento de este ítem cambió después de la revisión.",
      "non_objection_needs_confirmation": "Falta confirmar que nadie se opuso.",
      "meeting_already_purged": "Esta reunión ya fue borrada.",
      "segment_out_of_order": "Los fragmentos llegaron fuera de orden. La grabación quedó inconsistente.",
      "effectuation_target_mismatch": "Ese destino no sirve para este ítem.",
      "correction_span_outside_segment": "El texto corregido está fuera del fragmento original.",
      "legal_basis_missing": "La base legal de esta reunión no cierra. Avise al responsable.",
      "not_authorized": "Su perfil no permite esta acción.",
      "reviewer_not_authorized": "Su perfil no permite revisar esta reunión.",
      "meeting_restricted": "Esta reunión es restringida.",
      "erasure_not_authorized": "Solo el organizador o un administrador puede borrar esta reunión.",
      "meeting_not_found": "Reunión no encontrada en esta cuenta.",
      "item_not_found": "Ítem no encontrado en esta reunión.",
      "tenant_mismatch": "Este registro pertenece a otra empresa del sistema, no a la tuya. Revisa que iniciaste sesión en la cuenta correcta antes de volver a intentarlo.",
      "processing_record_missing": "No encontramos el registro de esta grabación en el sistema. Abre la reunión de nuevo desde la lista; si persiste, avisa al responsable con el número de la reunión.",
      "memory_fact_not_found": "Esa información ya no existe. Se olvidó o nunca llegó a guardarse. Actualiza la pantalla antes de volver a intentarlo.",
      "segment_not_found": "Este fragmento de la transcripción no se encontró. Puede que ya haya sido reemplazado. Actualiza la pantalla y vuelve a intentarlo.",
      "work_order_needs_registered_owner": "Esta orden de trabajo necesita un responsable ya registrado. Registra al responsable en el equipo antes de continuar.",
      "owner_not_in_tenant_registry": "El responsable indicado no está registrado en esta empresa. Regístralo o elige otro responsable ya registrado.",
      "processing_record_immutable": "Este registro ya está cerrado y no admite más cambios. Si necesitas corregir algo, avisa al responsable de cumplimiento.",
      "glossary_term_conflict": "Este término del glosario entra en conflicto con uno ya registrado. Ajusta el texto o usa el término existente.",
      "partial_decision_already_taken": "La decisión sobre esta grabación interrumpida ya se tomó. Abre la reunión desde la lista para ver qué se decidió.",
      "redaction_span_invalid": "El fragmento marcado para ocultar no es válido en este punto de la transcripción. Vuelve a seleccionar el fragmento sin pasarte del texto original.",
      "navegador_sem_gravacao": "Este navegador no graba audio. Use Chrome en el celular o en la computadora.",
      "microfone_negado": "El acceso al micrófono fue denegado. Permita el acceso para grabar.",
      "consentimento_ausente": "Marque el aviso de grabación antes de empezar.",
      "participantes_nao_declarados": "Diga cuántas personas hay en la sala antes de grabar.",
      "desconhecida": "La reunión rechazó esta acción por un motivo que esta pantalla aún no conoce ({{code}}). Avisa al responsable.",
      "transcript_empty": "La grabación no captó habla suficiente para generar el acta. Revise si el equipo quedó cerca de quien hablaba.",
      "extraction_model_unavailable": "El generador de actas no está configurado en esta cuenta. La reunión está guardada, avise al responsable.",
      "extraction_output_unparseable": "El generador de actas devolvió un resultado que no se pudo leer. La transcripción está guardada y se puede intentar de nuevo.",
      "extraction_unexpected_failure": "El acta no pudo generarse por una falla del servidor. La reunión y la transcripción están guardadas, y el acta puede generarse de nuevo. Si se repite, avise al responsable.",
      "no_anchored_item_survived": "Ningún ítem del acta se sostuvo en lo que se habló. La transcripción está guardada.",
      "anchor_not_found_in_transcript": "El acta citó un fragmento que no se encontró en la transcripción.",
      "extracao_sem_motivo": "El acta no se generó y el motor no informó el motivo. La reunión está guardada.",
      "falha_de_rede": "No se pudo conectar con el servidor. Revisa la conexión del equipo e inténtalo de nuevo.",
      "sessao_expirada": "Tu sesión expiró. Inicia sesión de nuevo para grabar la reunión.",
      "sem_permissao": "Tu perfil no permite abrir reuniones en esta cuenta. Pide al responsable que lo habilite.",
      "muitas_tentativas": "Demasiadas solicitudes en poco tiempo. Espera un minuto e inténtalo de nuevo.",
      "ata_nao_carregou": "El acta fue generada y está guardada, pero no se pudo cargar ahora. Cierra y vuelve a abrir la conversación, o inténtalo en unos instantes."
    },
    "espera": {
      "parou": "se detuvo antes de terminar, con {{minutos}} min grabados. ¿Procesar lo que se dijo, o descartar?",
      "processar": "Generar el acta de lo que se grabó",
      "descartar": "Descartar",
      "descartarAviso": "La grabación se borra y no vuelve."
    }
  },
  "painelConfirmacao": {
    "enviando": "Confirmando…",
    "tentarDeNovo": "Intentar de nuevo",
    "semConversa": "No se pudo enviar: esta conversación no está disponible. Recarga la página e inténtalo de nuevo.",
    "naoEnviou": "La confirmación no salió de la aplicación. No se guardó nada; revisa la conexión e inténtalo de nuevo."
  },
  "campoData": {
    "abrirCalendario": "Abrir calendario",
    "calendario": "Calendario",
    "mesAnterior": "Mes anterior",
    "mesSeguinte": "Mes siguiente",
    "diasDaSemana": "D,L,M,X,J,V,S",
    "placeholder": "dd/mm/aaaa"
  },
  "campoSelecao": {
    "selecionar": "Seleccionar"
  },
  "research": {
    "notice": {
      "running": "Buscando el plan del {{label}} · {{elapsed}} de hasta {{ceiling}}",
      "ready": "El plan del {{label}} llegó. Toca para verlo.",
      "failed": "No conseguí el plan del {{label}}. El plan provisional sigue valiendo.",
      "ceilingMinutes": "{{count}}min",
      "openAria": "Abrir la conversación donde empezó la búsqueda"
    },
    "provisionalBadge": "Provisional, buscando el manual del fabricante",
    "arrived": "Llegó el manual del fabricante, actualicé el plan.",
    "compare": {
      "title": "Llegó el manual del fabricante y tu plan ya estaba guardado",
      "added_one": "{{count}} tarea nueva en el manual",
      "added_other": "{{count}} tareas nuevas en el manual",
      "changed_one": "{{count}} tarea con periodicidad diferente",
      "changed_other": "{{count}} tareas con periodicidad diferente",
      "same_one": "{{count}} tarea igual",
      "same_other": "{{count}} tareas iguales",
      "apply": "Aplicar manual",
      "keep": "Conservar el mío"
    }
  },
  "ferramentas": {
    "nome": {
      "create_equipment": "Registré el equipo",
      "create_location": "Registré la ubicación",
      "create_maint_plan": "Armé el plan de mantenimiento",
      "create_task_list": "Armé la lista de tareas",
      "create_wo_operation": "Agregué una operación a la orden",
      "create_work_order": "Abrí una orden de trabajo",
      "get_equipment": "Abrí la ficha del equipo",
      "get_maint_plan": "Abrí el plan de mantenimiento",
      "get_plant_list": "Listé las plantas",
      "get_work_order": "Abrí la orden de trabajo",
      "list_materials": "Listé los materiales",
      "query_maintenance_metrics": "Consulté los indicadores de mantenimiento",
      "search_equipment": "Busqué equipos",
      "search_form": "Busqué formularios",
      "search_maint_plan": "Busqué planes de mantenimiento",
      "search_manufacturer": "Busqué fabricantes",
      "search_material": "Busqué materiales",
      "search_notification": "Busqué notificaciones",
      "search_team": "Busqué equipos de trabajo"
    },
    "parametro": {
      "dims": "Corte",
      "entity": "Registro",
      "filters": "Filtros",
      "from": "Desde",
      "limit": "Límite",
      "metrics": "Indicadores",
      "period": "Período",
      "query": "Búsqueda",
      "status": "Situación",
      "to": "Hasta"
    },
    "valor": {
      "area": "Área",
      "availability": "Disponibilidad",
      "backlog_weeks": "Backlog (semanas)",
      "compliance": "Cumplimiento del plan",
      "corrective": "Correctiva",
      "equipment": "Equipo",
      "location": "Ubicación",
      "month": "Mes",
      "mtbf": "MTBF",
      "mttr": "MTTR",
      "predictive": "Predictiva",
      "preventive": "Preventiva",
      "quarter": "Trimestre",
      "team": "Equipo",
      "week": "Semana"
    }
  },
  "schedule": {
    "review": {
      "historyUnavailable": "No se pudieron cargar las versiones guardadas.",
      "versions": "Versiones guardadas",
      "exportExcel": "Exportar versión Excel",
      "exportPdf": "Exportar versión PDF",
      "specialtyLoad": "Carga y capacidad por especialidad",
      "specialty": "Especialidad",
      "week": "Semana",
      "before": "Carga antes (h)",
      "after": "Carga después (h)",
      "capacity": "Capacidad (h)",
      "unknownCapacity": "No informada",
      "unknownSpecialty": "Especialidad no informada"
    },
    "unlinkedArea": "Sin área vinculada",
    "areaUnavailable": "Área no disponible",
    "areaMetadataError": "No se pudieron cargar las áreas. El cronograma sigue disponible.",
    "areaContext": "Área: {{names}}",
    "readOnly": "Solo lectura: solo un administrador o gestor puede mover o editar el cronograma.",
    "warning": {
      "totalShutdown": "Semana de parada total: la tarea se guardó de todos modos.",
      "totalShutdownWeek": "Semana {{week}} en parada total: la tarea se guardó de todos modos."
    },
    "level": {
      "title": "Nivelar carga",
      "description": "Revise la propuesta y su impacto antes de aplicar. Generar una propuesta no cambia fechas.",
      "impact": "Máximo semanal: {{before}} → {{after}} h. Desviación: {{beforeDeviation}} → {{afterDeviation}}.",
      "move": "{{plan}} · Semana {{from}} → {{to}} · {{hours}} h",
      "empty": "Ningún movimiento recomendado.",
      "propose": "Generar propuesta",
      "apply": "Aplicar propuesta"
    },
    "reloadRetry": "La versión se guardó, pero el cronograma no cargó. Use Guardar para volver a cargar.",
    "undoUnavailable": "Deshacer no disponible: el servidor no proporcionó un registro de restauración válido.",
    "undoExpired": "No se pudo deshacer: el cronograma cambió después del movimiento o el registro de deshacer expiró. Se recargó la grilla.",
    "title": "Cronograma Anual de {{weeks}} Semanas",
    "aiBadge": "{{count}} inferidos por la IA",
    "annualSummary": "{{equipment}} equipos · {{plans}} planes · {{orders}} OT en el año · {{hours}}h",
    "annualSummaryWithoutHours": "{{equipment}} equipos · {{plans}} planes · {{orders}} OT en el año · Horas sin estimar",
    "summary": "{{orders}} OT en el año · {{hours}}h",
    "currentWeek": "esta semana: {{orders}} órdenes · {{hours}}h",
    "equipmentCount": "{{count}} equipos",
    "blocked": "Bloqueado",
    "shutdown": "Parada Colectiva",
    "today": "Hoy",
    "crit": {
      "label": "Criticidad",
      "a": "A",
      "b": "B",
      "c": "C"
    },
    "picker": {
      "simulateSelected": "Simular {{count}} equipos",
      "simulatePlant": "Simular toda la planta",
      "loading": "Cargando el cronograma de 52 semanas…",
      "loadError": "No se pudo cargar el cronograma. Comprueba la conexión e inténtalo de nuevo con los controles de abajo.",
      "plant": "Planta",
      "choosePlant": "Seleccione una planta",
      "title": "Elige los equipos",
      "hint": "Elige uno o más equipos para ver el cronograma del año.",
      "criticalOnly": "Solo críticos A",
      "wholePlant": "Toda la planta",
      "viewSelected": "Ver {{count}} equipos",
      "empty": "Ningún equipo registrado en esta planta."
    },
    "commands": {
      "cronograma": {
        "label": "Cronograma del año",
        "description": "año de 52 semanas"
      }
    },
    "actions": {
      "versions": "Versiones guardadas",
      "expand": "Abrir cronograma",
      "save": "Guardar",
      "compare": "Línea Base",
      "compareDisabled": "Disponible en la próxima fase",
      "excel": "Excel",
      "pdf": "PDF A3",
      "exportExcel": "Exportar Excel (.xlsx) formateado para PCM",
      "exportPdf": "Exportar PDF formato A3 industrial",
      "saveVersion": "Grabar Simulación",
      "saveDisabled": "Disponible en la próxima fase",
      "exportError": "No se pudo exportar el cronograma.",
      "exportDisabled": "Nada que exportar: el filtro activo deja vacía la grilla de esta tarjeta.",
      "save": "Guardar"
    },
    "filters": {
      "all": "Todos ({{count}})",
      "criticalEquipment": "Críticos Grado A ({{count}})",
      "taskCriticalityA": "Tareas A ({{count}})",
      "search": "Filtrar equipo..."
    },
    "period": {
      "label": "Período del cronograma",
      "day": "Día",
      "week": "Semana",
      "month": "Mes",
      "year": "Año"
    },
    "status": {
      "hint": "Haga clic o arrastre una ocurrencia. Seleccione semanas en la regla para bloquearlas.",
      "capacity": "Capacidad del equipo: {{hours}}h",
      "scenario": "Escenario: {{name}} v{{version}}",
      "comparing": "Comparando con: {{label}}",
      "dragging": "Reprogramando: {{label}} · Semana {{from}} → Semana {{to}} · Desviación vs Línea Base: {{weeks}} Semanas ({{days}}d)",
      "loading": "Cargando cronograma…",
      "loadError": "No se pudo cargar el cronograma: {{message}}",
      "undo": "Deshacer",
      "teamLoad": "Carga del equipo: {{hours}}h/{{capacity}}h",
      "capacityUnknown": "Capacidad no informada",
      "capacityOver": "Por encima de la capacidad",
      "capacityIdeal": "Capacidad ideal"
    },
    "quarter": {
      "shutdown": "Parada Colectiva",
      "range": "Sem {{from}} - {{to}} · {{months}}",
      "assetHeader": "Activo y Criticidad",
      "months": {
        "1": "Ene - Mar",
        "2": "Abr - Jun",
        "3": "Jul - Sep",
        "4": "Oct - Dic"
      }
    },
    "isoYearColumns": "Semanas de {{year}}",
    "task": {
      "summary": "{{duration}} · {{technician}}",
      "edit": "Editar tarea",
      "addIntervention": "+ Intervención"
    },
      "year": {
        "label": "Año del cronograma",
        "single": "Solo existe escenario simulado para {{year}}.",
        "loadError": "No se pudo abrir el escenario de ese año."
      },
    "tabs": {
      "label": "Secciones del cronograma",
      "schedule": "Cronograma",
      "plans": "Planes",
      "cost": "Presupuesto y costos",
      "capacity": "Capacidad del equipo",
      "exclusions": "Avisos y exclusiones",
      "versions": "Versiones",
      "orders": "Órdenes de trabajo",
      "audit": "Auditoría"
    },
    "panels": {
      "plans": {
        "title": "Planes y tareas",
        "empty": "Ningún plan con tareas en este filtro.",
        "col": {
          "equipment": "Equipo",
          "plan": "Plan",
          "task": "Tarea",
          "criticality": "Crit.",
          "duration": "Duración",
          "source": "Origen",
          "rationale": "Justificación"
        },
        "inferred": "Inferido por IA",
        "reviewed": "Revisado"
      },
      "orders": {
        "title": "Órdenes de trabajo",
        "empty": "Ninguna orden en este filtro.",
        "simulated": "Simulada",
        "truncated": "Mostrando {{shown}} de {{total}} órdenes, por fecha. Use Excel para la lista completa.",
        "col": {
          "order": "Orden",
          "equipment": "Equipo",
          "plan": "Plan",
          "date": "Fecha",
          "week": "Semana",
          "status": "Estado",
          "hours": "Horas"
        },
        "status": {
          "done": "Concluida",
          "open": "Abierta",
          "planned": "Planificada",
          "overdue": "Atrasada"
        }
      },
      "exclusions": {
        "title": "Avisos y exclusiones",
        "empty": "Sin avisos: todos los planes de este filtro están en la grilla.",
        "week53": "2026 tiene 53 semanas ISO: mostrar 53 columnas no es un error.",
        "inactive": "Planes inactivos (fuera de la grilla)",
        "notSchedulable": "Planes sin fecha fija (por turno o por condición)",
        "blocks": "Bloqueos de fecha y paradas",
        "omitted": "{{count}} equipo(s) dado(s) de baja omitido(s) de la grilla.",
        "inactiveItem": "{{tag}} · {{plan}} está inactivo y no aparece en la grilla.",
        "notSchedulableItem": "{{tag}} · {{plan}} no se programa por fecha: {{band}}.",
        "blockItem": "{{kind}} · semanas {{from}} a {{to}} · {{reason}}",
        "blockKind": {
          "date_block": "Bloqueo de fecha",
          "total_shutdown": "Parada colectiva"
        }
      },
      "capacity": {
        "title": "Capacidad del equipo",
        "empty": "Ninguna semana con horas planificadas en este escenario.",
        "summary": "{{hours}}h planificadas · {{over}} semana(s) sobre la capacidad.",
        "col": {
          "week": "Semana",
          "hours": "Planificado",
          "capacity": "Capacidad",
          "load": "Carga",
          "status": "Estado"
        },
        "alert": {
          "ok": "Dentro de la capacidad",
          "over": "Sobre la capacidad",
          "idle": "Ociosa"
        }
      },
      "cost": {
        "title": "Presupuesto y costos",
        "empty": "Ningún costo previsto en este escenario.",
        "summary": "Material previsto: {{material}} · mano de obra: {{hours}}h.",
        "noBudget": "Presupuesto anual no informado: la tarjeta del cronograma no trae presupuesto, solo el previsto por semana.",
        "col": {
          "week": "Semana",
          "hours": "Mano de obra",
          "material": "Material"
        }
      },
      "loading": "Cargando…",
      "versions": {
        "title": "Versiones guardadas",
        "empty": "Aún no hay versiones guardadas. Use \"Guardar Simulación\" para conservar una.",
        "current": "En pantalla",
        "col": {
          "version": "Versión",
          "name": "Nombre",
          "date": "Guardada el",
          "current": "Estado"
        }
      },
      "audit": {
        "title": "Auditoría del escenario",
        "empty": "Ningún registro de auditoría para este escenario en los últimos 100 eventos del tenant.",
        "forbidden": "La auditoría solo está disponible para administradores.",
        "failed": "No se pudo cargar la auditoría ahora.",
        "col": {
          "at": "Cuándo",
          "action": "Acción",
          "actor": "Quién"
        }
      }
    },
    "plan": {
      "tolerance": "Tolerancia: −{{early}}% / +{{late}}%",
      "lineSymmetric": "{{cycle}} · {{hours}}h · ±{{tolerance}}%",
      "lineAsymmetric": "{{cycle}} · {{hours}}h · −{{early}}% / +{{late}}%",
      "summary": "{{cycle}} · {{hours}}h",
      "activate": "Activar"
    },
    "procedure": {
      "title": "Procedimiento",
      "empty": "Procedimiento no registrado"
    },
    "lane": {
      "choosePlan": "Elija el plan de este equipo",
      "collapse": "Contraer",
      "expand": "Expandir",
      "summary": "{{plans}} planes · {{orders}} OT",
      "addIntervention": "+ Intervención",
      "empty": "Ningún equipo coincide con este filtro."
    },
    "legend": {
      "aiInferred": "IA · contorno punteado indica dato inferido",
      "weekToday": "Semana actual",
      "weekBlocked": "Bloqueo de fecha",
      "weekShutdown": "Parada colectiva"
    },
    "occurrence": {
      "week": "S{{week}}",
      "weekBadge": "S{{week}}",
      "tooltip": "S{{week}} · {{status}}",
      "group_one": "{{count}} ocurrencia · S{{week}} · {{states}}",
      "group_other": "{{count}} ocurrencias · S{{week}} · {{states}}",
      "status": {
        "done": "Completada",
        "open": "Abierta",
        "planned": "Planificada",
        "overdue": "Atrasada"
      }
    },
    "footer": {
      "dragActive": "Drag & Drop Activo · Presione ESC para soltar",
      "escape": "Esc para descartar el arrastre",
      "escapeKey": "Esc",
      "dropHint": "Enter confirma · Esc descarta",
      "willWriteOrder": "Vista previa: llamada del plan {{label}} → S{{week}} · OT {{code}} se reprogramará",
      "selection": "Selección:",
      "technician": "Técnico Resp:",
      "impact": "Impacto de Línea:",
      "noImpact": "No informado",
      "discard": "Descartar",
      "confirm": "Confirmar Cambio",
      "writeDisabled": "Disponible en la próxima fase",
      "willWrite": "Vista previa: llamada del plan {{label}} → S{{week}} · se reprogramará",
      "noChange": "Sin cambios: {{label}} permanece en la semana {{week}}.",
      "scopeOnly": "Solo esta ocurrencia",
      "scopeFollowing": "Esta y las siguientes",
      "reasonLabel": "Motivo",
      "reasonRequiredHint": "Indique el motivo (tarea crítica fuera de tolerancia)",
      "operating": "Operación continua",
      "partialStop": "Parada parcial",
      "fullStop": "Parada total del equipo",
      "editTechnician": "Editar técnico responsable"
    },
    "dragError": {
      "invalidWeek": "La semana de destino no es válida o está fuera del horizonte del cronograma. Elija otra semana.",
      "conflict": "La ocurrencia cambió desde que se cargó esta pantalla. Actualice el cronograma e intente de nuevo."
    },
    "inlineEdit": {
      "duration": "Tiempo (min)",
      "technician": "Técnico",
      "team": "Equipo",
      "criticality": "Criticidad",
      "rationale": "Motivo",
      "rationalePlaceholder": "¿Por qué esta criticidad?",
      "save": "Guardar",
      "cancel": "Cancelar",
      "none": "-",
      "inferredBadge": "Inferido por IA"
    },
    "dateBlock": {
      "title": "Semanas {{from}} a {{to}}",
      "dateBlockKind": "Bloqueo de fecha",
      "totalShutdownKind": "Parada total",
      "confirm": "Confirmar bloqueo",
      "reasonPlaceholder": "¿Por qué esta ventana está bloqueada?",
      "multiplePlants": "El cronograma muestra más de una planta, filtre por una planta para bloquear fechas.",
      "noPlant": "Ningún equipo con planta en este cronograma."
    },
    "ack": {
      "title": "Valores completados por IA",
      "body": "Este planeamiento tiene {{count}} valores completados por IA ({{fields}}).",
      "warning": "La IA puede equivocarse. Revise los ítems marcados con la estrella de inferido antes de usar este cronograma para comprar material o reservar equipo.",
      "review": "Revisar los {{count}} ítems",
      "confirm": "Estoy consciente y quiero guardar"
    },
    "compare": {
      "orders": "Δ OT: {{delta}}",
      "hours": "Δ Horas: {{delta}}h",
      "cost": "Δ Costo: {{delta}}"
    },
    "intervention": {
      "visibilityUnverified": "La presencia en la cuadrícula aún no se ha verificado. Revise el período y los filtros actuales.",
      "createdWithoutCode": "Intervención creada. El número de la orden no está disponible.",
      "createdWithCode": "Intervención creada: {{code}}.",
      "reloadRetry": "La intervención se creó, pero el cronograma no se cargó. Intenta actualizarlo de nuevo; no se creará otra intervención.",
      "retry": "Actualizar cronograma",
      "description": "Descripción",
      "descriptionPlaceholder": "¿Qué se necesita hacer?",
      "confirm": "Abrir intervención"
    },
    "currentWeek": "esta semana: {{orders}} órdenes · {{hours}} h",
    "procedure": {
      "empty": "No hay ningún procedimiento registrado",
      "title": "Procedimiento"
    }
  },
  "platform": {
    "novaEmpresa": "Nueva empresa",
    "criarEmpresa": "Crear e invitar",
    "criandoEmpresa": "Creando…",
    "ajudaEmailDoAdmin": "Esta persona recibe la invitación por correo y entra como administradora de la empresa. Ella invita al resto del equipo.",
    "liberacoes": {
      "titulo": "Liberaciones",
      "subtitulo": "Funciones nuevas liberadas en este ambiente. La llave vale para todas las empresas.",
      "ligada": "Activada",
      "desligada": "Desactivada",
      "ligadaDev": "Activada (desarrollo)",
      "travadaDev": "En desarrollo la llave siempre está activada y no se desactiva.",
      "ambiente": "Ambiente",
      "dono": "Responsable",
      "venceEm": "Vence el",
      "oQueMuda": "Qué cambia en pantalla",
      "carregando": "Cargando liberaciones…",
      "vazio": "No hay llaves de liberación.",
      "erro": "No se pudo cargar o cambiar las liberaciones. Inténtalo de nuevo.",
      "ligar": "Activar {{nome}}",
      "desligar": "Desactivar {{nome}}"
    },
    "aba": "Empresas",
    "titulo": "Empresas de la plataforma",
    "subtitulo": "Todas las empresas registradas y las personas de cada una.",
    "buscarEmpresa": "Buscar empresa",
    "buscarPessoa": "Buscar persona",
    "escolhaUmaEmpresa": "Elige una empresa de la lista.",
    "plano": "Plan",
    "pessoasAtivas": "Personas activas",
    "pessoasTotal": "Personas registradas",
    "pessoaAtiva": "Activa",
    "pessoaInativa": "Inactiva",
    "suspenderEmpresa": "Suspender empresa",
    "reativarEmpresa": "Reactivar empresa",
    "novaPessoa": "Nueva persona",
    "editarPessoa": "Editar persona",
    "editar": "Editar",
    "desativar": "Desactivar",
    "reativar": "Reactivar",
    "cancelar": "Cancelar",
    "salvar": "Guardar",
    "salvando": "Guardando...",
    "fechar": "Cerrar",
    "emailNaoMuda": "El correo es la forma en que la persona entra. No se cambia aquí.",
    "convitesPendentes": "{{count}} invitación(es) creada(s) y aún no aceptada(s).",
    "situacao": {
      "active": "Activa",
      "suspended": "Suspendida"
    },
    "campo": {
      "email": "Correo",
      "nome": "Nombre",
      "papel": "Rol",
      "nomeDaEmpresa": "Nombre de la empresa",
      "emailDoAdmin": "Correo del administrador de la empresa"
    },
    "validacao": {
      "email": "Escribe un correo válido.",
      "nome": "Escribe el nombre.",
      "nomeDaEmpresa": "Indica el nombre de la empresa."
    },
    "papel": {
      "admin": "Administrador",
      "manager": "Gestor",
      "technician": "Técnico",
      "viewer": "Consulta"
    },
    "coluna": {
      "nome": "Nombre",
      "email": "Correo",
      "papel": "Rol",
      "situacao": "Situación",
      "acoes": "Acciones"
    },
    "confirmarSuspender": {
      "titulo": "¿Suspender esta empresa?",
      "mensagem": "Las personas de {{nome}} pierden el acceso mientras la empresa esté suspendida. No se borra nada y puedes reactivar cuando quieras."
    },
    "confirmarDesativar": {
      "titulo": "¿Desactivar a esta persona?",
      "mensagem": "{{nome}} pierde el acceso y sigue en la lista, marcada como inactiva. Puedes reactivar cuando quieras."
    },
    "erro": {
      "USER_EXISTS": "Ya existe una persona con este correo en esta empresa.",
      "USER_EXISTS_OTHER_TENANT": "Este correo ya pertenece a otra empresa.",
      "CANNOT_DEACTIVATE_SELF": "No puedes desactivarte a ti mismo.",
      "INVITE_FAILED": "No se pudo enviar la invitación. No se creó nada; intenta de nuevo.",
      "ROLE_NOT_PROVISIONED": "Esta empresa aún no tiene ese rol configurado.",
      "TENANT_NOT_FOUND": "Empresa no encontrada.",
      "USER_NOT_FOUND": "Persona no encontrada en esta empresa.",
      "FORBIDDEN_PLATFORM_ADMIN": "No tienes acceso a esta área.",
      "NETWORK": "Sin respuesta del servidor. Revisa la conexión e intenta de nuevo.",
      "DESCONHECIDO": "No se pudo completar. Intenta de nuevo; si se repite, avisa a soporte.",
      "INVITE_ALREADY_PENDING": "Esta persona ya fue invitada y todavía no aceptó.",
      "TENANT_SLUG_TAKEN": "Ya existe una empresa con ese nombre.",
      "CATALOG_NOT_SEEDED": "Esta base todavía no tiene el plan o el rol de administrador."
    }
  },
  "planComparison": {
    "title": "Comparación del plan",
    "equipment": "Equipo: {{manufacturer}} {{model}}",
    "summaryLabel": "Resumen de la comparación",
    "client": "Su plan",
    "reference": "Referencia",
    "absent": "No figura",
    "every": "Cada {{value}} {{unit}}",
    "noInterval": "Sin intervalo informado",
    "row": "Fila {{number}} de la planilla: {{text}}",
    "source": "Fuente: {{host}}",
    "unverified": "Fuente no verificada",
    "notCompared": "Unidades distintas: no se comparó numéricamente.",
    "assumir": "Asumir como plan oficial",
    "useEquipment": "Usar {{manufacturer}} {{model}}",
    "status": {
      "igual": "Igual",
      "intervalo_diferente": "Intervalo distinto",
      "falta_no_cliente": "Falta en su plan",
      "so_no_cliente": "Solo en su plan",
      "nao_comparavel": "No comparable"
    },
    "adopt": {
      "intervalo_diferente": "Usar el intervalo de la referencia",
      "falta_no_cliente": "Agregar a mi plan"
    },
    "unit": {
      "HOURS_one": "hora",
      "HOURS_other": "horas",
      "DAYS_one": "día",
      "DAYS_other": "días",
      "WEEKS_one": "semana",
      "WEEKS_other": "semanas",
      "MONTHS_one": "mes",
      "MONTHS_other": "meses",
      "YEARS_one": "año",
      "YEARS_other": "años",
      "CYCLES_one": "ciclo",
      "CYCLES_other": "ciclos"
    },
    "band": {
      "por_turno": "Por turno",
      "diaria": "Diaria",
      "semanal": "Semanal",
      "mensal": "Mensual",
      "trimestral": "Trimestral",
      "semestral": "Semestral",
      "anual": "Anual",
      "por_hora_operacao": "Por hora de operación",
      "por_condicao": "Por condición"
    }
  },
  "guardian": {
    "commands": {
      "label": "Crear agente",
      "sub": {
        "novo": "Describir un agente nuevo",
        "listar": "Ver tus agentes en el panel",
        "rodar": "Preparar un plan ahora",
        "pausar": "Detener las próximas ejecuciones",
        "editar": "Ajustar la regla del agente",
        "retomar": "Reanudar un agente pausado"
      },
      "loadAgents": "Cargar tus agentes"
    },
    "create": "Crear agente",
    "missing": "Aún sin definir",
    "inferred": "Inferencia: ver motivo",
    "specificApproval": "Su aprobación cubre únicamente este plan y estos efectos.",
    "expires": "Aprobación disponible hasta {{date}}",
    "results": "{{count}} resultados",
    "empty": "No hay agentes en esta conversación.",
    "recommended": "Recomendado",
    "readOnly": "Solo lectura",
    "sendAnswer": "Enviar respuesta",
    "deliveryFailed": "No se pudo enviar esta acción. Consulte el estado actual en la conversación antes de continuar.",
    "fields": {
      "where": "Dónde",
      "object": "Objeto",
      "action": "Acción",
      "when": "Cuándo",
      "exceptions": "Excepciones"
    },
    "state": {
      "DRAFT": "Borrador",
      "ENTRY_REVIEW": "Revisando definición",
      "CLARIFYING": "Falta una definición",
      "CONFIRMING": "Confirmación pendiente",
      "BLIND_CHECK": "Comprobando significado",
      "CAPABILITY_CHECK": "Comprobando capacidad",
      "DRY_RUNNING": "Simulación en curso",
      "EVIDENCE_BLOCKED": "Evidencia insuficiente",
      "READY": "Listo para activar",
      "ACTIVE": "Activo · propone y pide aprobación",
      "PLAN_REVIEW": "Plan en revisión",
      "AWAITING_APPROVAL": "Esperando aprobación",
      "EXECUTING": "Ejecutando plan aprobado",
      "RECONCILING": "Verificando resultado",
      "RECEIPT": "Resultado verificado",
      "PAUSED": "Pausado",
      "BLOCKED": "Bloqueado"
    },
    "card": {
      "agentPolicy": "Política del agente",
      "agentApproval": "Aprobar plan específico",
      "agentReceipt": "Resultado de la ejecución",
      "agentExplanation": "Explicación y auditoría",
      "agentPanel": "Agentes de mantenimiento",
      "agentRun": "Ejecución del agente",
      "agentBreaker": "Disyuntor del agente",
      "agentTemplates": "Modelos listos"
    },
    "approval": {
      "reviewing": "En revisión",
      "blocked": "Bloqueado",
      "awaiting_approval": "Esperando aprobación",
      "approved": "Aprobado",
      "rejected": "Rechazado",
      "expired": "Vencido"
    },
    "outcome": {
      "succeeded": "Comprobado",
      "partial": "Parcial",
      "failed": "Falló",
      "unverified": "Resultado no comprobado",
      "none": "Sin ejecución",
      "awaiting_approval": "Esperando aprobación"
    },
    "dryRun": {
      "not_started": "Sin iniciar",
      "running": "En curso",
      "sufficient": "Evidencia suficiente",
      "insufficient": "Evidencia insuficiente",
      "failed": "Falló"
    },
    "method": {
      "historical_replay": "Replay de historial real",
      "synthetic_history_replay": "Replay de historial sintético",
      "current_snapshot": "Vista previa del estado actual"
    },
    "review": {
      "approve": "Aprobó",
      "reject": "Rechazó",
      "unavailable": "No disponible"
    },
    "confirmation": {
      "pending": "Pendiente",
      "confirmed": "Confirmada"
    },
    "mode": {
      "manual": "Manual",
      "scheduled": "Programado"
    },
    "nextRun": "Próxima ejecución: {{date}}",
    "lastOutcome": "Último resultado",
    "effectPending": "La ejecución tiene asuntos pendientes. Consulte los motivos y la auditoría.",
    "samples": "{{count}} registros examinados",
    "d6": {
      "pending": "Comprensión en revisión",
      "blocked": "Comprensión bloqueada",
      "green": "Comprensión verificada"
    },
    "boolean": {
      "true": "Sí",
      "false": "No"
    },
    "noValue": "Sin valor",
    "recordedDecision": "Decisión de admisibilidad registrada",
    "admissibility": {
      "pending": "Admisibilidad pendiente",
      "accepted": "Admisibilidad aceptada",
      "rejected": "Admisibilidad rechazada"
    },
    "rejectionReason": "Motivo del rechazo",
    "confirmRejection": "Rechazar este plan",
    "checkState": "Consultar estado de los agentes",
    "run": {
      "meta": "versión {{version}} · {{trigger}} · {{date}}",
      "trace": "rastro {{trace}}",
      "receipt": "Recibo {{label}}",
      "created": "nuevo",
      "showAll": "Ver las {{count}} acciones",
      "step": {
        "pending": "pendiente",
        "pending_verification": "esperando verificación",
        "uncertain": "resultado incierto",
        "blocked": "bloqueado",
        "failed": "falló"
      },
      "status": {
        "running": "En ejecución",
        "completed": "Concluida",
        "nothing_to_do": "Nada que hacer",
        "awaiting_approval": "Esperando aprobación",
        "rejected_by_guardian": "Rechazada por Guardian",
        "rejected_by_human": "Rechazada por ti",
        "breaker_tripped": "Detenida por el disyuntor",
        "partial": "Parcial",
        "receipt_failed": "Recibo no verificado",
        "uncertain": "Resultado incierto",
        "failed": "Falló"
      }
    },
    "breaker": {
      "per_run": "Límite por ejecución",
      "per_day": "Límite del día",
      "per_tenant_day": "Límite diario de la empresa",
      "repeated_pattern": "Patrón repetido",
      "out_of_scope": "Fuera del alcance"
    },
    "rewrite": "Reescribir la regla",
    "activate": "Activar",
    "question": {
      "confirm": "Confirmar",
      "writeOther": "Escribir otra respuesta"
    },
    "panel": {
      "title": "Tus agentes",
      "count_one": "{{count}} activo de {{total}}",
      "count_other": "{{count}} activos de {{total}}",
      "close": "Cerrar panel de agentes",
      "open": "Abrir panel de agentes",
      "loading": "Cargando tus agentes…",
      "empty": "Aún no hay agentes. Describe en el chat lo que un agente debe hacer.",
      "more": "Ver más agentes",
      "pointer_one": "{{count}} agente en el panel de la derecha",
      "pointer_other": "{{count}} agentes en el panel de la derecha",
      "version": "versión {{version}}",
      "approvedBy": "aprobada por {{name}} el {{date}}",
      "runs": "Se ejecuta",
      "next": "Próxima",
      "lastRun": "Última ejecución",
      "never": "nunca"
    },
    "seal": {
      "explicit": "En el texto",
      "assumed": "Supuesto",
      "confirmed": "Confirmado",
      "missing": "Falta definir"
    },
    "understood": {
      "label": "Entendí así",
      "newVersion": "Nueva versión del agente (base: versión {{version}})",
      "youWrote": "Escribiste:",
      "tools": "Herramientas de AxiomGO que usará el agente",
      "limits": "hasta {{perRun}} acciones por ejecución y {{perDay}} por día"
    },
    "toolKind": {
      "read": "Solo lee",
      "write": "Cambia datos"
    },
    "autonomy": {
      "propose_and_ask": "Propone y pide tu aprobación antes de actuar",
      "act_within_limits": "Actúa dentro de los límites"
    },
    "rehearsal": {
      "history": "Ensayo en el historial real",
      "snapshot": "Vista previa del estado actual (no habilita la activación)",
      "result": "Habría cambiado {{affected}} de {{total}}",
      "examples": "ej.: {{examples}}",
      "status": "Ensayo: {{status}}"
    },
    "highRisk": "Alto riesgo: dos jueces de familias distintas"
  },
  "horizonGeneration": {
    "title": "Procesamiento de órdenes de trabajo",
    "period": "Período solicitado: {{from}} a {{to}} ({{months}} meses)",
    "loading": "Consultando el procesamiento…",
    "waiting": "Esperando procesamiento",
    "processing": "Procesando órdenes de trabajo",
    "completed": "Procesamiento completado",
    "partially_completed": "Procesamiento parcialmente completado",
    "failed": "El procesamiento falló",
    "unavailable": "El resultado aún no se puede verificar",
    "progress": "Planes procesados: {{finishedPlans}} de {{totalPlans}}",
    "totals": "Ocurrencias en esta ejecución: {{generated}} generadas, {{reused}} reutilizadas, {{skipped}} omitidas y {{failed}} fallidas.",
    "reconciliation": "{{generatedDistinct}} órdenes distintas vinculadas a las ocurrencias generadas; {{groupedOccurrences}} ocurrencias adicionales agrupadas en esas órdenes.",
    "reconciliationUnknown": "Este comprobante no permite confirmar la cantidad de órdenes distintas vinculadas a las ocurrencias generadas.",
    "orders_one": "{{count}} orden encontrada en el período solicitado.",
    "orders_other": "{{count}} órdenes encontradas en el período solicitado.",
    "failure": "Revise las órdenes existentes y actualice la consulta antes de intentar generar nuevamente.",
    "readError": "No se pudo actualizar la consulta. Se conservó el último resultado verificado cuando está disponible.",
    "paused": "La actualización automática está en pausa. Actualice para consultar el estado actual.",
    "refresh": "Actualizar procesamiento",
    "showOrders": "Ver órdenes de trabajo",
    "hideOrders": "Ocultar órdenes de trabajo",
    "previous": "Anterior",
    "next": "Siguiente",
    "orders_zero": "{{count}} órdenes encontradas en el período solicitado."
  },
  "axisCopy": {
    "transicao_apos_tag_base_pronta": [
      "Listo, {{tag}} registrado y su base está lista. Usted decide: ¿abrir una orden correctiva o armar el plan preventivo?",
      "{{tag}} guardado y su base está lista. ¿Qué sigue: una orden correctiva o un plan preventivo?",
      "Todo listo, {{tag}} registrado. Su base está lista: ¿correctiva o preventiva?",
      "Registré {{tag}}. La base está lista para usar. ¿Prefiere abrir una orden correctiva o armar primero el plan preventivo?",
      "{{tag}} ya está en el sistema y la base está completa. ¿Correctiva o preventiva, cuál primero?",
      "Bien, {{tag}} registrado. Su base está lista: ¿qué camino prefiere, correctiva o preventiva?",
      "{{tag}} registrado con éxito. Base lista. Ahora elija: abrir una orden correctiva o armar el plan preventivo.",
      "Guardé {{tag}}. Su base está lista: ¿vamos a una orden correctiva o armamos primero el plan preventivo?",
      "Perfecto, con {{tag}} su base está completa. Dígame: ¿correctiva ahora o preventiva?",
      "{{tag}} registrado, base lista. ¿Qué quiere hacer: correctiva o preventiva?",
      "Registré {{tag}}. Base lista. Próximo paso: ¿una orden correctiva o el plan preventivo?",
      "Listo, {{tag}} guardado. La base está armada: ¿empezamos con una orden correctiva o con un plan preventivo?"
    ],
    "transicao_apos_planta": [
      "Bien, planta {{planta}}. ¿En qué ubicación dentro de ella? Así las órdenes quedan organizadas por sector.",
      "Planta {{planta}}, entendido. Ahora la ubicación: el área o la línea donde está el equipo.",
      "De acuerdo, {{planta}}. Dígame la ubicación dentro de ella, área o línea.",
      "{{planta}}, correcto. ¿Qué ubicación dentro de la planta? Área, línea o sector.",
      "Listo, {{planta}}. Falta la ubicación: ¿dónde exactamente dentro de la planta?",
      "Planta {{planta}}. ¿En qué área o línea está el equipo?",
      "Entendido, {{planta}}. Ahora necesito la ubicación dentro de ella para que las órdenes salgan por sector.",
      "Vamos con {{planta}}. Dígame la ubicación dentro de la planta y seguimos.",
      "Perfecto, {{planta}}. ¿Dónde está dentro de la planta? Área o línea.",
      "Planta {{planta}}, entonces. Lo siguiente es la ubicación: área o línea.",
      "Bien, planta {{planta}}. ¿Y la ubicación? ¿Qué área o línea?",
      "Muy bien, {{planta}}. ¿Dónde está dentro de la planta: área, línea o sector?"
    ],
    "transicao_apos_localizacao": [
      "Bien, ubicación {{localizacao}}. Ahora la etiqueta, el código que identifica este equipo en su planta.",
      "{{localizacao}}, entendido. Falta la etiqueta: su código único. Puedo generar uno si lo prefiere.",
      "De acuerdo, {{localizacao}}. ¿Cómo quiere identificar este equipo? La etiqueta es su código.",
      "Listo, {{localizacao}}. Dígame la etiqueta, el código de identificación, o pida uno automático.",
      "Muy bien, {{localizacao}}. Ahora la etiqueta, el código que identifica el equipo.",
      "Entendido, {{localizacao}}. Ahora su etiqueta, el código único en la planta.",
      "Bien, {{localizacao}}. ¿Qué etiqueta quiere usar? También puedo generar uno.",
      "Vamos con {{localizacao}}. Falta la etiqueta, el código de identificación.",
      "Perfecto, {{localizacao}}. Dígame la etiqueta del equipo, su código.",
      "{{localizacao}}, correcto. Lo siguiente es la etiqueta.",
      "Correcto, {{localizacao}}. ¿Cómo identificamos este equipo? Necesito la etiqueta.",
      "Ubicación {{localizacao}}, entonces. Ahora la etiqueta, que lo identifica de forma única aquí."
    ]
  },
  "equipmentHistory": {
    "closureNote": "Informe de cierre",
    "unavailable": "No se pudo presentar el historial recibido. Vuelva a abrir la consulta para intentarlo de nuevo.",
    "equipment": "Equipo",
    "actions": "Acciones",
    "planEquipment": "Plan / equipo",
    "title": "Historial de {{tag}}",
    "summary": "{{totalWorkOrders}} órdenes y {{totalNotifications}} notificaciones en este recorte; {{activeMaintPlans}} planes activos en la consulta.",
    "scope": "Fuente: historial del equipo. Eventos limitados a {{limit}} registros por tipo; las fechas conservan la zona horaria de origen.",
    "returned": "{{count}} registros recibidos",
    "empty": "No hay registros en este recorte.",
    "previous": "Anterior",
    "next": "Siguiente",
    "page": "Página {{page}} de {{pages}}",
    "events": "Eventos",
    "plans": "Planes preventivos",
    "date": "Fecha y hora (origen)",
    "reference": "Referencia",
    "priority": "Prioridad",
    "status": "Estado",
    "description": "Descripción",
    "frequency": "Frecuencia / unidad",
    "last": "Última ejecución",
    "nextDue": "Próxima ejecución",
    "active": "Activo",
    "inactive": "Inactivo",
    "units": {"days": "días", "weeks": "semanas", "months": "meses", "hours": "horas", "cycles": "ciclos", "km": "km", "DAYS": "días", "WEEKS": "semanas", "MONTHS": "meses", "HOURS": "horas", "CYCLES": "ciclos"}
  },
  "readOnlyList": {
    "unavailable": "No se pudo mostrar esta lista. Vuelva a abrir la consulta para intentarlo de nuevo.",
    "yes": "Sí",
    "no": "No",
    "received": "{{count}} registros recibidos",
    "count": "{{count}} registros recibidos de {{total}} en el ámbito consultado",
    "empty": "No hay registros en este recorte.",
    "more": "Hay más registros fuera de este recorte.",
    "unknownScope": "La fuente no informó si hay más registros fuera de este recorte.",
    "sources": {
      "search_location": "Ubicaciones",
      "search_plant": "Plantas",
      "search_supplier": "Proveedores",
      "search_specialty": "Especialidades",
      "search_task_list": "Listas de tareas",
      "search_plan_calls": "Llamadas del plan",
      "search_failure_mode": "Modos de falla",
      "search_catalog": "Catálogo técnico",
      "list_team_members": "Miembros del equipo",
      "list_team_technicians": "Técnicos del equipo",
      "list_in_app_alerts": "Alertas",
      "list_import_catalog": "Plantillas de importación",
      "list_ltp_scenarios": "Escenarios de planificación",
      "get_proposals": "Propuestas",
      "get_stock_overview": "Existencias por planta",
      "query_materials_by_pattern": "Materiales por patrón",
      "get_record_history": "Historial del registro",
      "search_work_order": "Órdenes de trabajo",
      "search_technician": "Técnicos",
      "search_maint_plan": "Planes de mantenimiento"
    },
    "columns": {
      "code": "Código",
      "name": "Nombre",
      "description": "Descripción",
      "plant": "Planta",
      "parent": "Ubicación superior",
      "category": "Categoría",
      "active": "Activo",
      "specialty": "Especialidad",
      "operations": "Operaciones",
      "components": "Componentes",
      "reference": "Referencia",
      "dueDate": "Vencimiento",
      "plannedDate": "Fecha planificada",
      "shiftFollowing": "Desplaza siguientes",
      "status": "Estado",
      "movedAt": "Reprogramado en",
      "moveReason": "Motivo",
      "causes": "Causas",
      "manufacturer": "Fabricante",
      "model": "Modelo",
      "confidence": "Confianza",
      "lastResearched": "Última investigación",
      "role": "Rol",
      "membership": "Vínculo",
      "primary": "Principal",
      "additional": "Adicional",
      "type": "Tipo",
      "priority": "Prioridad",
      "title": "Título",
      "body": "Informe",
      "createdAt": "Creado en",
      "read": "Leído",
      "requiredFields": "Campos obligatorios",
      "optionalFields": "Campos opcionales",
      "anchorDate": "Inicio",
      "horizonWeeks": "Horizonte en semanas",
      "baselineYear": "Año base",
      "createdBy": "Autor",
      "equipment": "Equipo",
      "currentStock": "Existencias",
      "reservedStock": "Reservado",
      "available": "Disponible",
      "unit": "Unidad",
      "when": "Fecha y hora",
      "who": "Responsable",
      "action": "Acción",
      "detail": "Detalle",
      "unreadCount": "No leídos",
      "unreadCriticalCount": "Críticos no leídos",
      "unreadBeyondPage": "No leídos fuera del recorte",
      "page": "Página",
      "pageSize": "Tamaño de página",
      "limit": "Límite de consulta",
      "recordType": "Tipo de registro",
      "plannedStart": "Inicio programado",
      "plannedEnd": "Fin programado",
      "team": "Equipo",
      "availability": "Disponibilidad en la fecha"
    }
  }
}
